import { BuilderElement, ElementType, GlobalConfig } from '@/types/builder';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import { Pagination } from 'swiper/modules';
import { relative } from 'path';

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const template2GlobalConfig: GlobalConfig = {
  typography: [
    {
      name: 'Default',
      fontFamily: 'Inter',
      fontSize: '16px',
      fontWeight: '400',
      fontStyle: 'normal',
    },
    {
      name: 'Heading-1',
      fontFamily: 'Inter',
      fontSize: '44px',
      fontWeight: '700',
      fontStyle: 'normal',
    },
    {
      name: 'Heading-2',
      fontFamily: 'Inter',
      fontSize: '40px',
      fontWeight: '700',
      fontStyle: 'normal',
    },
    {
      name: 'Heading-3',
      fontFamily: 'Inter',
      fontSize: '36px',
      fontWeight: '700',
      fontStyle: 'normal',
    },
    {
      name: 'Heading-4',
      fontFamily: 'Inter',
      fontSize: '33px',
      fontWeight: '700',
      fontStyle: 'normal',
    },
    {
      name: 'Heading-5',
      fontFamily: 'Inter',
      fontSize: '28px',
      fontWeight: '700',
      fontStyle: 'normal',
    },
    {
      name: 'Heading-6',
      fontFamily: 'Inter',
      fontSize: '24px',
      fontWeight: '900',
      fontStyle: 'normal',
    },
    {
      name: 'Body',
      fontFamily: 'Inter',
      fontSize: '18px',
      fontWeight: '400',
      fontStyle: 'normal',
    },
    {
      name: 'Button',
      fontFamily: 'Inter',
      fontSize: '20px',
      fontWeight: '700',
      fontStyle: 'normal',
    },
  ],
  colors: {
    background: '#FFFFFF',
    forground: '#000000',
    primary: '#4DC7F4',
    secondary: '#FFB214',
    tertiary: '#454080',
    quaternary: '#D4339C',
    link: '#231F20',
    activeLink: '#1D4ED8',
  },
  breakpoints: {
    mobileMax: 640,
    tabletMin: 641,
    tabletMax: 1024,
    desktopMin: 1025,
  },
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    backgroundColor: 'background',
    color: 'forground',
    width: '100%',
  },
  children: [
    // Header Top Section
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        padding: '8px 0',
        backgroundColor: '#F5F5F5', // Neutral-4 equivalent
      },
      children: [
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
          },
          children: [
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                alignItems: 'center',
              },
              children: [
                {
                  id: generateId(),
                  type: 'image' as ElementType,
                  src: '/images/movyo/Digistore logo.svg',
                  alt: 'Digistore Logo',
                  styles: {
                    width: 'auto',
                    height: '20px',
                    objectFit: 'contain',
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                width: '1px',
                height: '20px',
                backgroundColor: '#5E5959',
                borderRadius: '1px',
              },
            },
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
              },
              children: [
                {
                  id: generateId(),
                  type: 'image' as ElementType,
                  src: '/images/movyo/lockIcon.webp',
                  alt: 'Lock Icon',
                  styles: {
                    width: '16px',
                    height: '16px',
                    objectFit: 'contain',
                  },
                },
                {
                  id: generateId(),
                  type: 'text' as ElementType,
                  content: 'Secure Order',
                  styles: {
                    color: '#317CF7',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    lineHeight: 'normal',
                    textTransform: 'uppercase',
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    // Main Header Menu
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        backgroundColor: 'background',
        transition: 'all 0.3s ease',
        width: '100%',
      },
      children: [
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '64px',
            position: 'relative',
            width: '100%',
            padding: '20px 50px 30px',
            maxWidth: '1450px',
            margin: '0 auto',
          },
          responsiveStyles: {
            tablet: {
              gap: '20px',
              padding: '10px 16px',
            },
            mobile: {
              gap: '20px',
              padding: '10px 16px',
            },
          },
          children: [
            // Logo
            {
              id: generateId(),
              type: 'logo' as ElementType,
              styles: {
                maxWidth: '136px',
                display: 'flex',
                alignItems: 'center',
              },
              responsiveStyles: {
                mobile: {
                  maxWidth: '90px',
                },
              },
              children: [
                {
                  id: generateId(),
                  type: 'image' as ElementType,
                  src: '/images/movyo/logo.webp',
                  alt: 'Logo',
                  styles: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  },
                },
              ],
            },
            // Desktop Navigation Links
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '42px',
                marginLeft: 'auto',
              },
              responsiveStyles: {
                tablet: {
                  display: 'none',
                },
                mobile: {
                  display: 'none',
                },
              },
              children: [
                {
                  id: generateId(),
                  type: 'link' as ElementType,
                  content: 'About',
                  styles: {
                    transition: 'all 0.3s ease',
                    textTransform: 'capitalize',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '22px',
                    color: 'forground',
                    position: 'relative',
                    textDecoration: 'none',
                  },
                  typography: 'Body',
                },
                {
                  id: generateId(),
                  type: 'link' as ElementType,
                  content: 'Ingredients',
                  styles: {
                    transition: 'all 0.3s ease',
                    textTransform: 'capitalize',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '22px',
                    color: 'forground',
                    position: 'relative',
                    textDecoration: 'none',
                  },
                  typography: 'Body',
                },
                {
                  id: generateId(),
                  type: 'link' as ElementType,
                  content: 'Why it works?',
                  styles: {
                    transition: 'all 0.3s ease',
                    textTransform: 'capitalize',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '22px',
                    color: 'forground',
                    position: 'relative',
                    textDecoration: 'none',
                  },
                  typography: 'Body',
                },
                {
                  id: generateId(),
                  type: 'link' as ElementType,
                  content: 'FAQ',
                  styles: {
                    transition: 'all 0.3s ease',
                    textTransform: 'capitalize',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '22px',
                    color: 'forground',
                    position: 'relative',
                    textDecoration: 'none',
                  },
                  typography: 'Body',
                },
              ],
            },
            // Desktop CTA Button
            {
              id: generateId(),
              type: 'button' as ElementType,
              content: 'BUY NOW',
              styles: {
                backgroundColor: '#F4B83D',
                color: 'forground',
                padding: '10.5px 27.5px',
                borderRadius: '24px',
                fontWeight: '700',
                fontSize: '20px',
                lineHeight: '24px',
                cursor: 'pointer',
                border: 'none',
                textTransform: 'capitalize',
                transition: 'all 0.3s ease',
                marginLeft: '42px',
              },
              typography: 'Button',
              responsiveStyles: {
                tablet: {
                  display: 'none',
                },
                mobile: {
                  display: 'none',
                },
              },
            },
            // Mobile Hamburger Icon
            {
              id: generateId(),
              type: 'button' as ElementType,
              content: '☰',
              interactionType: 'popup',
              triggerPopup: 'mobile-navigation',
              styles: {
                display: 'none',
                cursor: 'pointer',
                zIndex: '1001',
                backgroundColor: 'transparent',
                border: 'none',
                fontSize: '24px',
                marginLeft: 'auto',
                padding: '8px',
                borderRadius: '4px',
                transition: 'background-color 0.3s ease',
              },
              responsiveStyles: {
                tablet: {
                  display: 'block',
                  marginLeft: 'auto',
                },
                mobile: {
                  display: 'block',
                  marginLeft: 'auto',
                },
              },
            },
          ],
        },
      ],
    },
    // Mobile Menu Overlay
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        display: 'none',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.50)',
        zIndex: '998',
        opacity: '0',
        transition: 'opacity 0.3s ease',
        pointerEvents: 'none',
      },
      responsiveStyles: {
        tablet: {
          display: 'block',
        },
        mobile: {
          display: 'block',
        },
      },
      children: [],
    },
    // Mobile Menu
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        display: 'none',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: 'auto',
        backgroundColor: '#333',
        zIndex: '9999',
        transform: 'translateY(-100%)',
        transition: 'transform 0.3s ease',
        paddingBottom: '20px',
        pointerEvents: 'none',
      },
      responsiveStyles: {
        tablet: {
          display: 'block',
        },
        mobile: {
          display: 'block',
        },
      },
      children: [
        {
          id: generateId(),
          type: 'button' as ElementType,
          content: '✕',
          styles: {
            position: 'absolute',
            top: '20px',
            right: '20px',
            color: 'white',
            fontSize: '24px',
            cursor: 'pointer',
            backgroundColor: 'transparent',
            border: 'none',
            padding: '8px',
            borderRadius: '4px',
            transition: 'background-color 0.3s ease',
            zIndex: '10000',
          },
        },
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            padding: '16px 16px 0',
            marginTop: '60px',
          },
          children: [
            {
              id: generateId(),
              type: 'link' as ElementType,
              content: 'About',
              styles: {
                color: 'white',
                textDecoration: 'none',
                fontSize: '18px',
                fontWeight: '500',
                display: 'block',
                width: '100%',
                marginBottom: '15px',
                padding: '12px 0',
                transition: 'background-color 0.3s ease',
                borderRadius: '4px',
              },
            },
            {
              id: generateId(),
              type: 'link' as ElementType,
              content: 'Ingredients',
              styles: {
                color: 'white',
                textDecoration: 'none',
                fontSize: '18px',
                fontWeight: '500',
                display: 'block',
                width: '100%',
                marginBottom: '15px',
                padding: '12px 0',
                transition: 'background-color 0.3s ease',
                borderRadius: '4px',
              },
            },
            {
              id: generateId(),
              type: 'link' as ElementType,
              content: 'Why it works?',
              styles: {
                color: 'white',
                textDecoration: 'none',
                fontSize: '18px',
                fontWeight: '500',
                display: 'block',
                width: '100%',
                marginBottom: '15px',
                padding: '12px 0',
                transition: 'background-color 0.3s ease',
                borderRadius: '4px',
              },
            },
            {
              id: generateId(),
              type: 'link' as ElementType,
              content: 'FAQ',
              styles: {
                color: 'white',
                textDecoration: 'none',
                fontSize: '18px',
                fontWeight: '500',
                display: 'block',
                width: '100%',
                marginBottom: '15px',
                padding: '12px 0',
                transition: 'background-color 0.3s ease',
                borderRadius: '4px',
              },
            },
          ],
        },
        {
          id: generateId(),
          type: 'button' as ElementType,
          content: 'BUY NOW',
          styles: {
            backgroundColor: '#F4B83D',
            color: 'forground',
            padding: '16px 24px',
            borderRadius: '24px',
            fontWeight: '700',
            fontSize: '20px',
            lineHeight: '24px',
            cursor: 'pointer',
            border: 'none',
            width: 'calc(100% - 32px)',
            margin: '0 16px 20px',
            textTransform: 'capitalize',
            transition: 'all 0.3s ease',
          },
          typography: 'Button',
        },
      ],
    },
  ],
});

const createHeroSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    backgroundImage: "url('/images/movyo/heroBG.webp')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'background',
    overflow: 'hidden',
    width: '100%',
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '90px',
        width: '1450px',
        maxWidth: '1450px',
        margin: '0 auto',
        padding: '0 50px',
      },
      responsiveStyles: {
        tablet: {
          gap: '10px',
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
        mobile: {
          flexDirection: 'column-reverse',
          gap: '25px',
          width: '100%',
          padding: '0 16px',
        },
      },
      children: [
        // Left side content
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            maxWidth: '583px',
            marginTop: '205px',
            marginBottom: '191px',
            display: 'flex',
            flexDirection: 'column',
          },
          responsiveStyles: {
            tablet: {
              margin: '50px 0',
              maxWidth: '50%',
            },
            mobile: {
              marginTop: '0',
              marginBottom: '40px',
            },
          },
          children: [
            // Main title
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: "Supports your body's natural metabolic process",
              styles: {
                fontSize: '44px',
                fontWeight: '700',
                lineHeight: '52.8px',
                color: 'background',
                margin: '0 0 16px 0',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '32px',
                  lineHeight: '38.4px',
                },
              },
              typography: 'Heading-1',
            },
            // Subtitle
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: '– Just 5 Seconds a Day!',
              styles: {
                fontSize: '25px',
                fontWeight: '700',
                lineHeight: '174%',
                color: 'background',
                margin: '0 0 16px 0',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '20px',
                  lineHeight: '24px',
                },
              },
            },
            // Description
            {
              id: generateId(),
              type: 'paragraph' as ElementType,
              content:
                'Experience MOVYO, a revolutionary French Alpine breakthrough that naturally helps boosts metabolism, melts fat, and restores confidence. No diets or chemicals required.',
              styles: {
                fontSize: '18px',
                lineHeight: '23.4px',
                fontWeight: '600',
                color: 'background',
                marginTop: '16px',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '14px',
                  lineHeight: '18.2px',
                },
              },
            },
            // CTA Button Container
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                marginTop: '50px',
              },
              responsiveStyles: {
                tablet: {
                  marginTop: '20px',
                },
                mobile: {
                  marginTop: '16px',
                },
              },
              children: [
                {
                  id: generateId(),
                  type: 'button' as ElementType,
                  content: 'BUY NOW',
                  styles: {
                    backgroundColor: '#F4B83D',
                    color: 'forground',
                    padding: '10.5px 27.5px',
                    borderRadius: '24px',
                    fontWeight: '700',
                    fontSize: '20px',
                    lineHeight: '24px',
                    cursor: 'pointer',
                    border: 'none',
                    textTransform: 'capitalize',
                    transition: 'all 0.3s ease',
                  },
                  typography: 'Button',
                },
              ],
            },
          ],
        },
        // Right side - Product image
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            flex: '1',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          children: [
            {
              id: generateId(),
              type: 'image' as ElementType,
              src: '/images/movyo/dynamic-images/bottles-1.svg',
              alt: 'Hero Image',
              styles: {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              },
            },
          ],
        },
      ],
    },
  ],
});

const createOfferBeltSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    paddingBottom: '113px',
    width: '100%',
    overflow: 'hidden',
  },
  responsiveStyles: {
    tablet: {
      paddingBottom: '30px',
    },
    mobile: {
      paddingBottom: '30px',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        overflow: 'hidden',
        width: '100%',
        position: 'relative',
      },
      children: [
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            width: 'max-content',
            animation: 'marquee-scroll 20s linear infinite',
          },
          children: [
            // First set of offer items
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
                padding: '8px 0',
                backgroundColor: '#E6F3FF', // DayBreakBlue-light equivalent
                minWidth: 'max-content',
              },
              children: [
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Movyo offering a massive discount, get yours now!',
                      styles: {
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '17.5px',
                        color: '#1890FF', // DayBreakBlue equivalent
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '24px',
                        height: '24px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/energy_savings_leaf.webp',
                          alt: 'offer-icon',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Movyo offering a massive discount, get yours now!',
                      styles: {
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '17.5px',
                        color: '#1890FF',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '24px',
                        height: '24px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/energy_savings_leaf.webp',
                          alt: 'offer-icon',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Movyo offering a massive discount, get yours now!',
                      styles: {
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '17.5px',
                        color: '#1890FF',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '24px',
                        height: '24px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/energy_savings_leaf.webp',
                          alt: 'offer-icon',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Movyo offering a massive discount, get yours now!',
                      styles: {
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '17.5px',
                        color: '#1890FF',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '24px',
                        height: '24px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/energy_savings_leaf.webp',
                          alt: 'offer-icon',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Second set of offer items (duplicate for seamless loop)
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
                padding: '8px 0',
                backgroundColor: '#E6F3FF',
                minWidth: 'max-content',
              },
              children: [
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Movyo offering a massive discount, get yours now!',
                      styles: {
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '17.5px',
                        color: '#1890FF',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '24px',
                        height: '24px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/energy_savings_leaf.webp',
                          alt: 'offer-icon',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Movyo offering a massive discount, get yours now!',
                      styles: {
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '17.5px',
                        color: '#1890FF',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '24px',
                        height: '24px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/energy_savings_leaf.webp',
                          alt: 'offer-icon',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Movyo offering a massive discount, get yours now!',
                      styles: {
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '17.5px',
                        color: '#1890FF',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '24px',
                        height: '24px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/energy_savings_leaf.webp',
                          alt: 'offer-icon',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Movyo offering a massive discount, get yours now!',
                      styles: {
                        fontSize: '14px',
                        fontWeight: '700',
                        lineHeight: '17.5px',
                        color: '#1890FF',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '24px',
                        height: '24px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/energy_savings_leaf.webp',
                          alt: 'offer-icon',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createTestimonialsHeaderSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: 'container' as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    paddingBottom: '25.5px',
    backgroundColor: 'background',
    width: '100%',
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1450px',
        maxWidth: '1450px',
        margin: '0 auto',
        padding: '0 50px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
        mobile: {
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
      },
      children: [
        // Testimonials Header
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            textAlign: 'center',
            paddingBottom: '64px',
          },
          responsiveStyles: {
            tablet: {
              paddingBottom: '40px',
            },
            mobile: {
              paddingBottom: '30px',
            },
          },
          children: [
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: 'Real People. Real Transformations.',
              styles: {
                fontSize: '42px',
                fontWeight: '700',
                color: 'forground',
                margin: '0 0 8px 0',
                lineHeight: '1.2',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '32px',
                },
                mobile: {
                  fontSize: '28px',
                },
              },
            },
            {
              id: generateId(),
              type: 'paragraph' as ElementType,
              content:
                'Inspiring success stories from everyday individuals who reclaimed their lives with MOVYO',
              styles: {
                fontSize: '20px',
                fontWeight: '400',
                lineHeight: '28px',
                color: 'forground',
                margin: '0',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '18px',
                  lineHeight: '24px',
                },
                mobile: {
                  fontSize: '16px',
                  lineHeight: '22px',
                },
              },
            },
          ],
        },
        // Testimonials Swiper Container
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
          },
          children: [
            // Swiper Container
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                width: '100%',
                height: '420px',
                overflow: 'hidden',
                position: 'relative',
                className: 'testimonial-swiper',
              },
              responsiveStyles: {
                tablet: {
                  height: 'auto',
                },
                mobile: {
                  height: 'auto',
                },
              },
              attributes: {
                id: 'testimonial-carousel',
              },
              children: [
                // Swiper Wrapper
                {
                  id: generateId(),
                  type: 'carousel' as ElementType,
                  autoPlay: { desktop: true },
                  loop: { desktop: true },
                  pagination: { desktop: true },
                  slidesPerView: { desktop: 3, tablet: 2, mobile: 1 },
                  spaceBetween: { desktop: 30, tablet: 16, mobile: 8 },
                  autoplayDelay: { desktop: 2500, mobile: 2000 },
                  styles: {
                    backgroundColor: 'background',
                    gap: '80px',
                    width: '100%',
                    // maxWidth: "1274px",
                    margin: '0 auto',
                    // padding: "40px 0 40px 0",
                  },
                  responsiveStyles: {
                    tablet: {
                      // flexDirection: "column",
                      // alignItems: "center",
                      gap: '40px',
                      // padding: "20px 0 20px 0",
                    },
                    mobile: {
                      // flexDirection: "column",
                      // alignItems: "center",
                      gap: '20px',
                      padding: '0',
                    },
                  },
                  children: [
                    {
                      clientImage: '/images/movyo/client2.webp',
                      clientName: 'Darwin M., 45, Oregon',
                      reviewContents:
                        "MOVYO made it so easy for me man! I've always struggled with late-night cravings, but those just faded after a few weeks. I've lost 14 pounds without feeling deprived or cutting out my favorite foods. And no weird side effects!",
                      reviewMark: 5,
                    },
                    {
                      clientImage: '/images/movyo/client3.webp',
                      clientName: 'Rachel T., 39, New Jersey',
                      reviewContents:
                        "After countless diets and supplements, I had pretty much given up... Then I found MOVYO. I didn't expect much, but within a month my snacking stopped, and I felt more in control. I'm down 10 pounds, and the best part is I didn't feel anxious or 'off' like with other stuff.",
                      reviewMark: 5,
                    },
                    {
                      clientImage: '/images/movyo/client1.webp',
                      clientName: 'Karen M., 52 – Scottsdale, Arizona',
                      reviewContents:
                        "I've tried everything for my weight over the years, but MOVYO was the 1st thing that actually worked without making me feel wired or jittery. In just 6 weeks, my craaavings disappeared and I dropped 2 pant sizes without changing my diet drastically.",
                      reviewMark: 5,
                    },
                    {
                      clientImage: '/images/movyo/client4.webp',
                      clientName: 'Linda J., 47 – Tampa, Florida',
                      reviewContents:
                        "With MOVYO, I finally feel like my metabolism woke up again. I'm not constantly thinking about food anymore, and my energy is stable throughout the day, it's like my body finally found its balance.",
                      reviewMark: 5,
                    },
                    {
                      clientImage: '/images/movyo/client5.webp',
                      clientName: 'Denver, Colorado',
                      reviewContents:
                        "At my age, losing weight felt impossible… until I found MOVYO. I've lost 18 pounds since March And my energy levels feel more stable all day long with no crash, this stuff is the real deal.",
                      reviewMark: 5,
                    },
                  ].map((client) => ({
                    id: generateId(),
                    type: 'container' as ElementType,
                    styles: {
                      flexShrink: '0',
                      // width: "372px",
                      height: 'auto',
                      margin: '0 10px',
                      transition: 'all 0.3s ease',
                      className: 'swiper-slide',
                    },
                    responsiveStyles: {
                      tablet: {
                        margin: '0',
                        minWidth: '200px',
                        padding: '0',
                      },
                      mobile: {
                        width: '100%',
                        margin: '0',
                      },
                    },
                    children: [
                      {
                        id: generateId(),
                        type: 'container' as ElementType,
                        styles: {
                          padding: '17px 29px',
                          border: '1px solid #D9D9D9',
                          backgroundColor: '#FAFAFA',
                          borderRadius: '10px',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column',
                          gap: '8px',
                          height: '100%',
                          boxSizing: 'border-box',
                          className: 'review-card',
                        },
                        responsiveStyles: {
                          tablet: {
                            padding: '15px 20px',
                          },
                          mobile: {
                            padding: '15px 20px',
                          },
                        },
                        children: [
                          {
                            id: generateId(),
                            type: 'container' as ElementType,
                            styles: {
                              width: '52px',
                              height: '52px',
                              borderRadius: '50%',
                              overflow: 'hidden',
                              flexShrink: '0',
                              className: 'profile-image',
                            },
                            children: [
                              {
                                id: generateId(),
                                type: 'image' as ElementType,
                                src: client.clientImage,
                                alt: 'Darwin M.',
                                styles: {
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                },
                              },
                            ],
                          },
                          {
                            id: generateId(),
                            type: 'heading' as ElementType,
                            content: client.clientName,
                            styles: {
                              fontSize: '16px',
                              fontWeight: '700',
                              lineHeight: '24px',
                              color: 'forground',
                              margin: '0',
                              textAlign: 'center',
                            },
                          },
                          {
                            id: generateId(),
                            type: 'paragraph' as ElementType,
                            content: client.reviewContents,
                            styles: {
                              fontSize: '14px',
                              fontWeight: '400',
                              lineHeight: '20px',
                              color: 'forground',
                              textAlign: 'center',
                              margin: '0',
                              flexGrow: '1',
                              display: 'flex',
                              alignItems: 'center',
                              className: 'review-text',
                            },
                          },
                          {
                            id: generateId(),
                            type: 'container' as ElementType,
                            styles: {
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              flexShrink: '0',
                              className: 'stars',
                            },
                            children: Array(client.reviewMark)
                              .fill(null)
                              .map(() => ({
                                id: generateId(),
                                type: 'image' as ElementType,
                                src: '/images/movyo/star.svg',
                                alt: 'Star',
                                styles: {
                                  width: '36px',
                                  height: '36px',
                                  objectFit: 'contain',
                                  className: 'star',
                                },
                              })),
                          },
                        ],
                      },
                    ],
                  })),
                  // children1: [
                  //   // Review 1
                  //   {
                  //     id: generateId(),
                  //     type: "container" as ElementType,
                  //     styles: {
                  //       flexShrink: "0",
                  //       width: "372px",
                  //       height: "auto",
                  //       margin: "0 10px",
                  //       transition: "all 0.3s ease",
                  //       className: "swiper-slide",
                  //     },
                  //     responsiveStyles: {
                  //       tablet: {
                  //         width: "calc(33.333% - 10px)",
                  //         margin: "0",
                  //         minWidth: "200px",
                  //         padding: "0",
                  //       },
                  //       mobile: {
                  //         width: "100%",
                  //         margin: "0",
                  //       },
                  //     },
                  //     children: [
                  //       {
                  //         id: generateId(),
                  //         type: "container" as ElementType,
                  //         styles: {
                  //           padding: "17px 29px",
                  //           border: "1px solid #D9D9D9",
                  //           backgroundColor: "#FAFAFA",
                  //           borderRadius: "10px",
                  //           transition: "all 0.3s ease",
                  //           display: "flex",
                  //           alignItems: "center",
                  //           flexDirection: "column",
                  //           gap: "8px",
                  //           height: "100%",
                  //           boxSizing: "border-box",
                  //           className: "review-card",
                  //         },
                  //         responsiveStyles: {
                  //           tablet: {
                  //             padding: "15px 20px",
                  //           },
                  //           mobile: {
                  //             padding: "15px 20px",
                  //           },
                  //         },
                  //         children: [
                  //           {
                  //             id: generateId(),
                  //             type: "container" as ElementType,
                  //             styles: {
                  //               width: "52px",
                  //               height: "52px",
                  //               borderRadius: "50%",
                  //               overflow: "hidden",
                  //               flexShrink: "0",
                  //               className: "profile-image",
                  //             },
                  //             children: [
                  //               {
                  //                 id: generateId(),
                  //                 type: "image" as ElementType,
                  //                 src: "/images/movyo/client2.webp",
                  //                 alt: "Darwin M.",
                  //                 styles: {
                  //                   width: "100%",
                  //                   height: "100%",
                  //                   objectFit: "cover",
                  //                 },
                  //               },
                  //             ],
                  //           },
                  //           {
                  //             id: generateId(),
                  //             type: "heading" as ElementType,
                  //             content: "Darwin M., 45, Oregon",
                  //             styles: {
                  //               fontSize: "16px",
                  //               fontWeight: "700",
                  //               lineHeight: "24px",
                  //               color: "#000000",
                  //               margin: "0",
                  //               textAlign: "center",
                  //             },
                  //           },
                  //           {
                  //             id: generateId(),
                  //             type: "paragraph" as ElementType,
                  //             content:
                  //               "MOVYO made it so easy for me man! I've always struggled with late-night cravings, but those just faded after a few weeks. I've lost 14 pounds without feeling deprived or cutting out my favorite foods. And no weird side effects!",
                  //             styles: {
                  //               fontSize: "14px",
                  //               fontWeight: "400",
                  //               lineHeight: "20px",
                  //               color: "#000000",
                  //               textAlign: "center",
                  //               margin: "0",
                  //               flexGrow: "1",
                  //               display: "flex",
                  //               alignItems: "center",
                  //               className: "review-text",
                  //             },
                  //           },
                  //           {
                  //             id: generateId(),
                  //             type: "container" as ElementType,
                  //             styles: {
                  //               display: "flex",
                  //               alignItems: "center",
                  //               gap: "8px",
                  //               flexShrink: "0",
                  //               className: "stars",
                  //             },
                  //             children: Array(5)
                  //               .fill(null)
                  //               .map(() => ({
                  //                 id: generateId(),
                  //                 type: "image" as ElementType,
                  //                 src: "/images/movyo/star.svg",
                  //                 alt: "Star",
                  //                 styles: {
                  //                   width: "36px",
                  //                   height: "36px",
                  //                   objectFit: "contain",
                  //                   className: "star",
                  //                 },
                  //               })),
                  //           },
                  //         ],
                  //       },
                  //     ],
                  //   },
                  //   // Review 2
                  //   {
                  //     id: generateId(),
                  //     type: "container" as ElementType,
                  //     styles: {
                  //       flexShrink: "0",
                  //       width: "496px",
                  //       height: "auto",
                  //       margin: "0 10px",
                  //       transition: "all 0.3s ease",
                  //       className: "swiper-slide",
                  //     },
                  //     responsiveStyles: {
                  //       tablet: {
                  //         width: "calc(33.333% - 10px)",
                  //         margin: "0",
                  //         minWidth: "200px",
                  //         padding: "0",
                  //       },
                  //       mobile: {
                  //         width: "100%",
                  //         margin: "0",
                  //       },
                  //     },
                  //     children: [
                  //       {
                  //         id: generateId(),
                  //         type: "container" as ElementType,
                  //         styles: {
                  //           padding: "5px", // thickness of the gradient border
                  //           borderRadius: "15px",
                  //           background:
                  //             "linear-gradient(90deg, #1FD5FF, #AFA6E1, #E3A1D6)",
                  //           boxSizing: "border-box",
                  //         },
                  //         children: [
                  //           {
                  //             id: generateId(),
                  //             type: "container" as ElementType,
                  //             styles: {
                  //               borderRadius: "10px", // smaller than the outer for inner rounding
                  //               padding: "57px 40px",
                  //               width: "100%",
                  //               height: "100%",
                  //               boxSizing: "border-box",
                  //               backgroundColor: "#FAFAFA",
                  //               display: "flex",
                  //               flexDirection: "column",
                  //               alignItems: "center",
                  //               gap: "8px",
                  //             },
                  //             responsiveStyles: {
                  //               tablet: {
                  //                 padding: "30px 20px",
                  //               },
                  //               mobile: {
                  //                 padding: "30px 20px",
                  //               },
                  //             },
                  //             children: [
                  //               {
                  //                 id: generateId(),
                  //                 type: "container" as ElementType,
                  //                 styles: {
                  //                   width: "52px",
                  //                   height: "52px",
                  //                   borderRadius: "50%",
                  //                   overflow: "hidden",
                  //                   flexShrink: "0",
                  //                   className: "profile-image",
                  //                 },
                  //                 children: [
                  //                   {
                  //                     id: generateId(),
                  //                     type: "image" as ElementType,
                  //                     src: "/images/movyo/client3.webp",
                  //                     alt: "Rachel T.",
                  //                     styles: {
                  //                       width: "100%",
                  //                       height: "100%",
                  //                       objectFit: "cover",
                  //                     },
                  //                   },
                  //                 ],
                  //               },
                  //               {
                  //                 id: generateId(),
                  //                 type: "heading" as ElementType,
                  //                 content: "Rachel T., 39, New Jersey",
                  //                 styles: {
                  //                   fontSize: "16px",
                  //                   fontWeight: "700",
                  //                   lineHeight: "24px",
                  //                   color: "#000000",
                  //                   margin: "0",
                  //                   textAlign: "center",
                  //                 },
                  //               },
                  //               {
                  //                 id: generateId(),
                  //                 type: "paragraph" as ElementType,
                  //                 content:
                  //                   "After countless diets and supplements, I had pretty much given up... Then I found MOVYO. I didn't expect much, but within a month my snacking stopped, and I felt more in control. I'm down 10 pounds, and the best part is I didn't feel anxious or 'off' like with other stuff.",
                  //                 styles: {
                  //                   fontSize: "14px",
                  //                   fontWeight: "400",
                  //                   lineHeight: "20px",
                  //                   color: "#000000",
                  //                   textAlign: "center",
                  //                   margin: "0",
                  //                   flexGrow: "1",
                  //                   display: "flex",
                  //                   alignItems: "center",
                  //                   className: "review-text",
                  //                 },
                  //               },
                  //               {
                  //                 id: generateId(),
                  //                 type: "container" as ElementType,
                  //                 styles: {
                  //                   display: "flex",
                  //                   alignItems: "center",
                  //                   gap: "8px",
                  //                   flexShrink: "0",
                  //                   className: "stars",
                  //                 },
                  //                 children: Array(5)
                  //                   .fill(null)
                  //                   .map(() => ({
                  //                     id: generateId(),
                  //                     type: "image" as ElementType,
                  //                     src: "/images/movyo/star.svg",
                  //                     alt: "Star",
                  //                     styles: {
                  //                       width: "36px",
                  //                       height: "36px",
                  //                       objectFit: "contain",
                  //                       className: "star",
                  //                     },
                  //                   })),
                  //               },
                  //             ],
                  //           },
                  //         ],
                  //       },
                  //     ],
                  //   },

                  //   // Review 3
                  //   {
                  //     id: generateId(),
                  //     type: "container" as ElementType,
                  //     styles: {
                  //       flexShrink: "0",
                  //       width: "372px",
                  //       height: "auto",
                  //       margin: "0 10px",
                  //       transition: "all 0.3s ease",
                  //       className: "swiper-slide",
                  //     },
                  //     responsiveStyles: {
                  //       tablet: {
                  //         width: "calc(33.333% - 10px)",
                  //         margin: "0",
                  //         minWidth: "200px",
                  //         padding: "0",
                  //       },
                  //       mobile: {
                  //         width: "100%",
                  //         margin: "0",
                  //       },
                  //     },
                  //     children: [
                  //       {
                  //         id: generateId(),
                  //         type: "container" as ElementType,
                  //         styles: {
                  //           padding: "17px 29px",
                  //           border: "1px solid #D9D9D9",
                  //           backgroundColor: "#FAFAFA",
                  //           borderRadius: "10px",
                  //           transition: "all 0.3s ease",
                  //           display: "flex",
                  //           alignItems: "center",
                  //           flexDirection: "column",
                  //           gap: "8px",
                  //           height: "100%",
                  //           boxSizing: "border-box",
                  //           className: "review-card",
                  //         },
                  //         responsiveStyles: {
                  //           tablet: {
                  //             padding: "15px 20px",
                  //           },
                  //           mobile: {
                  //             padding: "15px 20px",
                  //           },
                  //         },
                  //         children: [
                  //           {
                  //             id: generateId(),
                  //             type: "container" as ElementType,
                  //             styles: {
                  //               width: "52px",
                  //               height: "52px",
                  //               borderRadius: "50%",
                  //               overflow: "hidden",
                  //               flexShrink: "0",
                  //               className: "profile-image",
                  //             },
                  //             children: [
                  //               {
                  //                 id: generateId(),
                  //                 type: "image" as ElementType,
                  //                 src: "/images/movyo/client1.webp",
                  //                 alt: "Karen M.",
                  //                 styles: {
                  //                   width: "100%",
                  //                   height: "100%",
                  //                   objectFit: "cover",
                  //                 },
                  //               },
                  //             ],
                  //           },
                  //           {
                  //             id: generateId(),
                  //             type: "heading" as ElementType,
                  //             content: "Karen M., 52 – Scottsdale, Arizona",
                  //             styles: {
                  //               fontSize: "16px",
                  //               fontWeight: "700",
                  //               lineHeight: "24px",
                  //               color: "#000000",
                  //               margin: "0",
                  //               textAlign: "center",
                  //             },
                  //           },
                  //           {
                  //             id: generateId(),
                  //             type: "paragraph" as ElementType,
                  //             content:
                  //               "I've tried everything for my weight over the years, but MOVYO was the 1st thing that actually worked without making me feel wired or jittery. In just 6 weeks, my craaavings disappeared and I dropped 2 pant sizes without changing my diet drastically.",
                  //             styles: {
                  //               fontSize: "14px",
                  //               fontWeight: "400",
                  //               lineHeight: "20px",
                  //               color: "#000000",
                  //               textAlign: "center",
                  //               margin: "0",
                  //               flexGrow: "1",
                  //               display: "flex",
                  //               alignItems: "center",
                  //               className: "review-text",
                  //             },
                  //           },
                  //           {
                  //             id: generateId(),
                  //             type: "container" as ElementType,
                  //             styles: {
                  //               display: "flex",
                  //               alignItems: "center",
                  //               gap: "8px",
                  //               flexShrink: "0",
                  //               className: "stars",
                  //             },
                  //             children: Array(5)
                  //               .fill(null)
                  //               .map(() => ({
                  //                 id: generateId(),
                  //                 type: "image" as ElementType,
                  //                 src: "/images/movyo/star.svg",
                  //                 alt: "Star",
                  //                 styles: {
                  //                   width: "36px",
                  //                   height: "36px",
                  //                   objectFit: "contain",
                  //                   className: "star",
                  //                 },
                  //               })),
                  //           },
                  //         ],
                  //       },
                  //     ],
                  //   },
                  // ],
                },
              ],
            },
          ],
        },
        // Order Now Button
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '20px',
          },
          responsiveStyles: {
            tablet: {
              marginTop: '30px',
            },
            mobile: {
              marginTop: '30px',
            },
          },
          children: [
            {
              id: generateId(),
              type: 'button' as ElementType,
              content: 'ORDER NOW',
              styles: {
                backgroundColor: '#F4B83D',
                color: 'forground',
                padding: '16px 24px',
                borderRadius: '24px',
                fontWeight: '700',
                fontSize: '20px',
                lineHeight: '24px',
                cursor: 'pointer',
                border: 'none',
                textTransform: 'capitalize',
                transition: 'all 0.3s ease',
              },
              typography: 'Button',
              responsiveStyles: {
                tablet: {
                  fontSize: '18px',
                  padding: '14px 20px',
                },
                mobile: {
                  fontSize: '16px',
                  padding: '12px 18px',
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createProductIntroSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: 'container' as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    padding: '64px 0 58px',
    backgroundColor: 'background',
    width: '100%',
  },
  responsiveStyles: {
    mobile: {
      padding: '50px 0',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1450px',
        maxWidth: '1450px',
        margin: '0 auto',
        padding: '0 50px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
        mobile: {
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
      },
      children: [
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'space-between',
            gap: '24px',
          },
          responsiveStyles: {
            mobile: {
              flexDirection: 'column',
            },
          },
          children: [
            // Secret Image (Desktop)
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                maxWidth: '385px',
                width: '100%',
                height: 'auto',
                borderRadius: '24px',
                overflow: 'hidden',
              },
              responsiveStyles: {
                tablet: {
                  display: 'none',
                },
                mobile: {
                  display: 'none',
                },
              },
              children: [
                {
                  id: generateId(),
                  type: 'image' as ElementType,
                  src: '/images/movyo/secreat.webp',
                  alt: 'secreat',
                  styles: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  },
                },
              ],
            },
            // Secret Content
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                flexDirection: 'column',
                gap: '21px',
                flexGrow: '1',
              },
              children: [
                {
                  id: generateId(),
                  type: 'heading' as ElementType,
                  content:
                    'The 5-Second French Alpine Routine. Helps Flush Fat Naturally, No Extreme Measures!',
                  styles: {
                    fontSize: '18px',
                    fontWeight: '700',
                    lineHeight: '24px',
                    color: 'forground',
                    margin: '0',
                  },
                  responsiveStyles: {
                    mobile: {
                      fontSize: '16px',
                      lineHeight: '20px',
                    },
                  },
                },
                {
                  id: generateId(),
                  type: 'heading' as ElementType,
                  content:
                    'Unlock the Secret to Effortless, Lasting Weight Loss',
                  styles: {
                    fontSize: '33px',
                    fontWeight: '700',
                    lineHeight: '40px',
                    color: '#1890FF', // lightBlue equivalent
                    margin: '0',
                    maxWidth: '500px',
                  },
                  responsiveStyles: {
                    mobile: {
                      fontSize: '20px',
                      lineHeight: '24px',
                    },
                  },
                  typography: 'Heading-4',
                },
                // Secret Image (Mobile) - Shows after title and subtitle on mobile
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    width: '100%',
                    display: 'none', // Hidden on desktop
                  },
                  responsiveStyles: {
                    tablet: {
                      display: 'block',
                    },
                    mobile: {
                      display: 'block',
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'image' as ElementType,
                      src: '/images/movyo/secreat.webp',
                      alt: 'secreat',
                      styles: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: 'paragraph' as ElementType,
                  content:
                    "If you're tired of spending thousands on diets, injections, and programs that never deliver lasting results, you're not alone. For years, expensive treatments and restrictive plans have left you feeling frustrated and drained. But what if the secret to sustainable weight loss has been hidden in plain sight all along?",
                  styles: {
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    color: 'forground',
                    margin: '0',
                  },
                  typography: 'Body',
                  responsiveStyles: {
                    mobile: {
                      fontSize: '14px',
                      lineHeight: '20px',
                    },
                  },
                },
                {
                  id: generateId(),
                  type: 'paragraph' as ElementType,
                  content:
                    "Introducing MOVYO. A revolutionary, science-backed capsule that captures a 5-second morning secret from the French Alps. It naturally awakens your body's own fat-burning hormone, GLP-1, so you can finally lose weight safely, effectively, and permanently",
                  styles: {
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    color: 'forground',
                    margin: '0',
                  },
                  typography: 'Body',
                  responsiveStyles: {
                    mobile: {
                      fontSize: '14px',
                      lineHeight: '20px',
                    },
                  },
                },
                {
                  id: generateId(),
                  type: 'paragraph' as ElementType,
                  content: 'Ignite Your Metabolism. Reclaim Your Life!',
                  styles: {
                    fontSize: '18px',
                    fontWeight: '700',
                    lineHeight: '24px',
                    color: 'forground',
                    margin: '0',
                  },
                  responsiveStyles: {
                    mobile: {
                      fontSize: '16px',
                      lineHeight: '20px',
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createWhyMovyoWorksSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    padding: '35px 0 161px',
    backgroundColor: 'background',
    width: '100%',
  },
  responsiveStyles: {
    mobile: {
      padding: '0 0 129px',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1450px',
        maxWidth: '1450px',
        margin: '0 auto',
        padding: '0 50px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
        mobile: {
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
      },
      children: [
        // Header
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            textAlign: 'center',
          },
          children: [
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: 'Why MOVYO Works When Nothing Else Does',
              styles: {
                fontSize: '40px',
                fontWeight: '700',
                lineHeight: '150%',
                color: 'forground',
                margin: '0',
              },
              responsiveStyles: {
                mobile: {
                  lineHeight: '48px',
                },
              },
              typography: 'Heading-2',
            },
            {
              id: generateId(),
              type: 'paragraph' as ElementType,
              content:
                "Most weight loss products offer temporary fixes. But MOVYO targets the root cause, that is your body's natural ability to regulate weight. Our unique formula, based on breakthrough research, features potent natural ingredients that work together to support your metabolism and reduce cravings.",
              styles: {
                fontSize: '18px',
                fontWeight: '400',
                lineHeight: '24px',
                color: 'forground',
                maxWidth: '770px',
                margin: '8px auto 0',
              },
              typography: 'Body',
            },
          ],
        },
        // Grid Container
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '24px',
            maxWidth: '894px',
            margin: '17px auto 0',
          },
          responsiveStyles: {
            mobile: {
              gridTemplateColumns: 'repeat(1, 1fr)',
              gap: '24px',
            },
          },
          children: [
            // First Column
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
              },
              children: [
                // Item 1
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    padding: '24px',
                    borderRadius: '10px',
                    gap: '16px',
                    position: 'relative',
                    zIndex: '1',
                    backgroundImage:
                      'linear-gradient(90deg, #fafafa00 0%, #fafafa 99.92%)',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        right: '0px',
                        bottom: '0px',
                        zIndex: '-1',
                        pointerEvents: 'none',
                        padding: '1.5px',
                        borderRadius: '10px',
                        mask: 'linear-gradient(#ffffff 0px, #ffffff 0px) content-box subtract, linear-gradient(#ffffff 0px, #ffffff 0px)',
                        backgroundImage:
                          'linear-gradient(90deg, #00000000, #00000000, #d9d9d9c2)',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        margin: '0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: '01:',
                          styles: {
                            fontSize: '56px',
                            fontWeight: '900',
                            lineHeight: '46px',
                            color: '#595959',
                          },
                        },
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: '🧠',
                          styles: {
                            fontSize: '40px',
                            fontWeight: '900',
                            lineHeight: '46px',
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: 'heading' as ElementType,
                      content: 'Helps activate the Vagus Nerve',
                      styles: {
                        fontSize: '24px',
                        fontWeight: '900',
                        lineHeight: '36px',
                        color: 'primary',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'MOVYO targets the gut-brain axis by stimulating the vagus nerve, which plays a key role in hunger regulation and metabolic control.',
                      styles: {
                        fontSize: '18px',
                        fontWeight: '500',
                        lineHeight: '24px',
                        color: 'forground',
                        margin: '0',
                      },
                    },
                  ],
                },
                // Item 3
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    padding: '24px',
                    borderRadius: '10px',
                    gap: '16px',
                    position: 'relative',
                    zIndex: '1',
                    backgroundImage:
                      'linear-gradient(90deg, #fafafa00 0%, #fafafa 99.92%)',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        right: '0px',
                        bottom: '0px',
                        zIndex: '-1',
                        pointerEvents: 'none',
                        padding: '1.5px',
                        borderRadius: '10px',
                        mask: 'linear-gradient(#ffffff 0px, #ffffff 0px) content-box subtract, linear-gradient(#ffffff 0px, #ffffff 0px)',
                        backgroundImage:
                          'linear-gradient(90deg, #00000000, #00000000, #d9d9d9c2)',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        margin: '0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: '03:',
                          styles: {
                            fontSize: '56px',
                            fontWeight: '900',
                            lineHeight: '46px',
                            color: '#595959',
                          },
                        },
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: '🔥',
                          styles: {
                            fontSize: '40px',
                            fontWeight: '900',
                            lineHeight: '46px',
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: 'heading' as ElementType,
                      content: 'Helps enhance Fat Metabolism',
                      styles: {
                        fontSize: '24px',
                        fontWeight: '900',
                        lineHeight: '36px',
                        color: 'primary',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Cayenne, Ginseng, and Alpha Lipoic Acid accelerate fat burning and improve mitochondrial function for sustained energy.',
                      styles: {
                        fontSize: '18px',
                        fontWeight: '500',
                        lineHeight: '24px',
                        color: 'forground',
                        margin: '0',
                      },
                    },
                  ],
                },
                // Success Text (First Column) - Hidden on mobile
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    maxWidth: '175px',
                    margin: '0 auto',
                    textAlign: 'center',
                    position: 'relative',
                  },
                  responsiveStyles: {
                    mobile: {
                      display: 'none',
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'heading' as ElementType,
                      content: 'Successful Fat loss 🎉',
                      styles: {
                        fontSize: '32px',
                        fontWeight: '600',
                        lineHeight: '38px',
                        color: 'forground',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        position: 'absolute',
                        top: '-47px',
                        right: '-158px',
                        width: '264px',
                        height: '259px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/VectorArrow.svg',
                          alt: 'arrow Image',
                          styles: {
                            width: '100%',
                            height: '100%',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // Second Column
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                marginTop: '24px',
              },
              responsiveStyles: {
                mobile: {
                  marginTop: '0px',
                },
              },
              children: [
                // Item 2
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    padding: '24px',
                    borderRadius: '10px',
                    gap: '16px',
                    position: 'relative',
                    zIndex: '1',
                    backgroundImage:
                      'linear-gradient(270deg, #fafafa00 0%, #FAFAFA 100%)',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        right: '0px',
                        bottom: '0px',
                        padding: '1.5px',
                        borderRadius: '10px',
                        zIndex: '-1',
                        pointerEvents: 'none',
                        WebkitMask:
                          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                        WebkitMaskComposite: 'destination-out',
                        maskComposite: 'exclude, subtract',
                        backgroundImage:
                          'linear-gradient(90deg, #d9d9d9c2, #00000000, #00000000)',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        margin: '0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: '02:',
                          styles: {
                            fontSize: '56px',
                            fontWeight: '900',
                            lineHeight: '46px',
                            color: '#595959',
                          },
                        },
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: '🌿',
                          styles: {
                            fontSize: '40px',
                            fontWeight: '900',
                            lineHeight: '46px',
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: 'heading' as ElementType,
                      content: 'Boosts Natural GLP-1 Production',
                      styles: {
                        fontSize: '24px',
                        fontWeight: '900',
                        lineHeight: '36px',
                        color: 'primary',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        "Ingredients like Berberine and Green Tea Extract help trigger the body's own production of GLP-1, a hormone that reduces appetite and balances blood sugar.",
                      styles: {
                        fontSize: '18px',
                        fontWeight: '500',
                        lineHeight: '24px',
                        color: 'forground',
                        margin: '0',
                      },
                    },
                  ],
                },
                // Item 4
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    padding: '24px',
                    borderRadius: '10px',
                    gap: '16px',
                    position: 'relative',
                    zIndex: '1',
                    backgroundImage:
                      'linear-gradient(270deg, #fafafa00 0%, #FAFAFA 100%)',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        right: '0px',
                        bottom: '0px',
                        padding: '1.5px',
                        borderRadius: '10px',
                        zIndex: '-1',
                        pointerEvents: 'none',
                        WebkitMask:
                          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                        WebkitMaskComposite: 'destination-out',
                        maskComposite: 'exclude, subtract',
                        backgroundImage:
                          'linear-gradient(90deg, #d9d9d9c2, #00000000, #00000000)',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        margin: '0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: '04:',
                          styles: {
                            fontSize: '56px',
                            fontWeight: '900',
                            lineHeight: '46px',
                            color: '#595959',
                          },
                        },
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: '🥗',
                          styles: {
                            fontSize: '40px',
                            fontWeight: '900',
                            lineHeight: '46px',
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: 'heading' as ElementType,
                      content: 'Reduces Cravings & Supports Fullness',
                      styles: {
                        fontSize: '24px',
                        fontWeight: '900',
                        lineHeight: '36px',
                        color: 'primary',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Zinc, Chromium, and Banaba Leaf help stabilize insulin response and blood sugar, leading to fewer cravings and longer-lasting satiety.',
                      styles: {
                        fontSize: '18px',
                        fontWeight: '500',
                        lineHeight: '24px',
                        color: 'forground',
                        margin: '0',
                      },
                    },
                  ],
                },
                // Success Text (Second Column) - Shows on mobile for last item
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    maxWidth: '175px',
                    margin: '0 auto',
                    textAlign: 'center',
                    position: 'relative',
                    display: 'none', // Hidden on desktop
                  },
                  responsiveStyles: {
                    tablet: {
                      display: 'none',
                    },
                    mobile: {
                      display: 'block',
                      margin: '0 auto 0 0',
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'heading' as ElementType,
                      content: 'Successful Fat loss 🎉',
                      styles: {
                        fontSize: '32px',
                        fontWeight: '600',
                        lineHeight: '38px',
                        color: 'forground',
                        margin: '0',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        position: 'absolute',
                        top: '-47px',
                        right: '-158px',
                        width: '264px',
                        height: '259px',
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/VectorArrow.svg',
                          alt: 'arrow Image',
                          styles: {
                            width: '100%',
                            height: '100%',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createWhatsInsideSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    padding: '53px 0 46px',
    marginTop: '-113px',
    backgroundImage: 'url(/images/movyo/insideBG.webp)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    width: '100%',
  },
  responsiveStyles: {
    tablet: {
      marginTop: '-113px',
    },
    mobile: {
      marginTop: '-30px',
      padding: '34px 0 38px',
      backgroundImage:
        'linear-gradient(159deg, #6FC3E9 0%, #DEF8FF 32.9%, #F0F4FA 62.09%, #BDA5CA 88.96%)',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1270px',
        maxWidth: '1270px',
        margin: '0 auto',
        padding: '0 30px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
        mobile: {
          maxWidth: '100%',
          padding: '0 16px',
          width: '100%',
        },
      },
      children: [
        // Title
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {},
          children: [
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: "What's Inside",
              styles: {
                fontSize: '40px',
                fontWeight: '700',
                color: 'forground',
                textAlign: 'left',
                margin: '0',
              },
              typography: 'Heading-2',
              responsiveStyles: {
                tablet: {
                  textAlign: 'center',
                  paddingTop: '3rem',
                },
                mobile: {
                  textAlign: 'center',
                  paddingTop: '3rem',
                },
              },
            },
          ],
        },
        // Content
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            marginTop: '58px',
            display: 'flex',
            alignItems: 'center',
          },
          responsiveStyles: {
            tablet: {
              flexDirection: 'column-reverse',
              marginTop: '30px',
            },
            mobile: {
              flexDirection: 'column-reverse',
              marginTop: '30px',
            },
          },
          children: [
            // Left Column
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                width: '60%',
                display: 'flex',
                flexDirection: 'column',
                gap: '14px',
              },
              responsiveStyles: {
                tablet: {
                  width: '100%',
                },
                mobile: {
                  width: '100%',
                  gap: '16px',
                },
              },
              children: [
                // Ingredient Items
                ...[
                  {
                    img: '/images/movyo/insideItem1.svg',
                    title: 'Alpha Lipoic Acid',
                    desc: 'Supports insulin sensitivity and reduces inflammation',
                  },
                  {
                    img: '/images/movyo/insideItem2.svg',
                    title: 'Resveratrol',
                    desc: 'Promotes cellular energy and efficient fat burning',
                  },
                  {
                    img: '/images/movyo/insideItem3.svg',
                    title: 'Bifidobacterium breve',
                    desc: 'Enhances metabolism and nutrient absorption',
                  },
                  {
                    img: '/images/movyo/insideItem4.svg',
                    title: 'Akkermansia muciniphila',
                    desc: 'Boosts gut health and stimulates natural GLP-1 production',
                  },
                  {
                    img: '/images/movyo/insideItem5.svg',
                    title: 'Prickly Pear Cactus',
                    desc: 'Balances blood sugar and curbs cravings naturally',
                  },
                  {
                    img: '/images/movyo/insideItem6.svg',
                    title: 'Konjac Glucomannan',
                    desc: 'Provides essential prebiotic fiber to fuel beneficial gut bacteria and promote satiety',
                  },
                ].map((item, idx) => ({
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    display: 'flex',
                    alignItems: 'stretch',
                    justifyContent: 'flex-start',
                    gap: '28px',
                  },
                  responsiveStyles: {
                    mobile: {
                      alignItems: 'center',
                      gap: '10px',
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        width: '88px',
                        minWidth: '88px',
                        height: '88px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                      },
                      responsiveStyles: {
                        tablet: {
                          width: '70px',
                          height: 'auto',
                        },
                        mobile: {
                          width: '50px',
                          height: 'auto',
                          border: '3px solid #D1C4E9',
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: item.img,
                          alt: item.title,
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        display: 'flex',
                        position: 'relative',
                        alignItems: 'flex-start',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        height: 'auto',
                        maxWidth: '676px',
                        width: '100%',
                      },
                      responsiveStyles: {
                        tablet: {
                          maxWidth: '100%',
                        },
                        mobile: {
                          maxWidth: '100%',
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'heading' as ElementType,
                          content: `<strong>${item.title}</strong> - ${item.desc}`,
                          styles: {
                            position: 'relative',
                            fontSize: '18px',
                            fontWeight: '700',
                            color: 'forground',
                            width: '100%',
                            maxHeight: '49px',
                            height: '100%',
                          },
                          responsiveStyles: {
                            mobile: {
                              fontSize: '12px',
                              lineHeight: '14px',
                            },
                          },
                        },
                        // Border line and dot (pseudo-elements simulated)
                        {
                          id: generateId(),
                          type: 'container' as ElementType,
                          styles: {
                            position: 'absolute',
                            left: '0',
                            bottom: '-14px',
                            width: '100%',
                            height: '1px',
                            backgroundColor: 'forground',
                          },
                        },
                        {
                          id: generateId(),
                          type: 'container' as ElementType,
                          styles: {
                            position: 'absolute',
                            right: '0',
                            bottom: '-15px',
                            width: '4px',
                            height: '4px',
                            borderRadius: '50%',
                            backgroundColor: 'forground',
                          },
                        },
                      ],
                    },
                  ],
                })),
                // Order Button
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    marginTop: '50px',
                    marginLeft: '116px',
                  },
                  responsiveStyles: {
                    mobile: {
                      margin: '20px auto 0',
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'link' as ElementType,
                      href: '#pricing',
                      content: 'Order Now',
                      styles: {
                        display: 'inline-block',
                        fontWeight: '700',
                        fontSize: '20px',
                        borderRadius: '24px',
                        padding: '10.5px 27.5px',
                        backgroundColor: '#F4B83D',
                        color: 'forground',
                        textDecoration: 'none',
                        textTransform: 'capitalize',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                      },
                      typography: 'Button',
                      responsiveStyles: {
                        mobile: {
                          padding: '9.5px 34px',
                        },
                      },
                    },
                  ],
                },
              ],
            },
            // Right Column
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                width: '40%',
              },
              responsiveStyles: {
                mobile: {
                  width: '100%',
                },
              },
              children: [
                {
                  id: generateId(),
                  type: 'image' as ElementType,
                  src: '/images/movyo/insideImage.svg',
                  alt: 'Inside Illustration',
                  styles: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createPricingSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: 'container' as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundImage: 'linear-gradient(0deg, #ffffff 64%, #eddd5300 100%)',
    padding: '100px 0 0',
    width: '100%',
  },
  responsiveStyles: {
    tablet: {
      padding: '80px 0 0',
    },
    mobile: {
      padding: '50px 0 0',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1270px',
        maxWidth: '1270px',
        margin: '0 auto',
        padding: '0 30px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '0 20px',
        },
        mobile: {
          maxWidth: '100%',
          padding: '0 16px',
        },
      },
      children: [
        // Title
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: { textAlign: 'center' },
          children: [
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: "Get the Offers before it's too late!",
              styles: {
                fontSize: '40px',
                fontWeight: '700',
                color: 'forground',
                margin: '0',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '32px',
                },
                mobile: {
                  fontSize: '28px',
                },
              },
              typography: 'Heading-2',
            },
          ],
        },
        // Pricing Cards
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            marginTop: '105px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '32px',
          },
          responsiveStyles: {
            tablet: {
              flexDirection: 'column',
              marginTop: '100px',
              gap: '20px',
            },
            mobile: {
              flexDirection: 'column',
              marginTop: '70px',
              gap: '16px',
            },
          },
          children: [
            // 1 Month Supply
            createPricingCard({
              title: '1 Month Supply',
              price: '$69',
              img: '/images/movyo/price1.webp',
              certifications: [
                '/images/movyo/easy.webp',
                '/images/movyo/gurantee.webp',
                '/images/movyo/money.webp',
              ],
              features: [
                'Ships Immediately',
                'Basic plan access',
                'Email support',
              ],
              orderLink: '/upsell?b=U-1A1',
              orderText: 'SELECT THIS PLAN',
              orderBtnClass: 'secondary',
            }),
            // 6-Month Package
            createPricingCard({
              title: '6-Month Package',
              price: '$49',
              img: '/images/movyo/price2.webp',
              certifications: [
                '/images/movyo/easy.webp',
                '/images/movyo/gurantee.webp',
                '/images/movyo/easy.webp',
                '/images/movyo/money.webp',
              ],
              features: [
                'Love Your Body Again',
                'Forever Fit Advanced Guide',
                '1-on-1 Transformation Call',
                'Free Priority US Shipping',
                'VIP customer support',
              ],
              orderLink: '/upsell?b=U-3A1',
              orderText: 'BUY NOW',
              orderBtnClass: '',
              guarantee: '/images/movyo/guarantee.webp',
              paymentOptions: '/images/movyo/payment-options.svg',
              totalPrice: '$294',
              touchIcon: '/images/movyo/touch.svg',
            }),
            // 3-Month Package
            createPricingCard({
              title: '3-Month Package',
              price: '$59',
              img: '/images/movyo/price3.webp',
              certifications: [
                '/images/movyo/easy.webp',
                '/images/movyo/gurantee.webp',
                '/images/movyo/money.webp',
              ],
              features: [
                'Love Your Body Again',
                'Progress tracking tools',
                'Priority shipping',
                'Community access',
              ],
              orderLink: '/upsell?b=U-2A1',
              orderText: 'SELECT THIS PLAN',
              orderBtnClass: 'secondary',
              totalPrice: '$177',
            }),
          ],
        },
      ],
    },
  ],
});

// Helper for pricing card
function createPricingCard({
  title,
  price,
  img,
  certifications,
  features,
  orderLink,
  orderText,
  orderBtnClass,
  guarantee,
  paymentOptions,
  totalPrice,
  touchIcon,
}: {
  title?: string;
  price?: string;
  img?: string;
  certifications?: string[];
  features?: string[];
  orderLink?: string;
  orderText?: string;
  orderBtnClass?: string;
  guarantee?: string;
  paymentOptions?: string;
  totalPrice?: string;
  touchIcon?: string;
}) {
  const desktopChildren = [
    // Guarantee (only for 6-Month Package)
    ...(guarantee
      ? [
          {
            id: generateId(),
            type: 'container' as ElementType,
            styles: {
              width: '171.215px',
              height: '153.319px',
              margin: '0 auto',
              marginBottom: '-80px',
              zIndex: '2',
              position: 'absolute',
              top: '-103px',
              left: '50%',
              transform: 'translateX(-50%)',
            },
            children: [
              {
                id: generateId(),
                type: 'image' as ElementType,
                src: guarantee,
                alt: 'Guarantee',
                styles: { width: '100%', height: '100%', objectFit: 'contain' },
              },
            ],
          },
        ]
      : []),
    // Title
    {
      id: generateId(),
      type: 'heading' as ElementType,
      content: title,
      styles: {
        fontSize: '30px',
        fontWeight: '700',
        color: 'forground',
        textAlign: 'center',
        paddingBottom: '32px',
      },
    },
    // Product Image
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '100%',
        height: title === '6-Month Package' ? '303px' : '221px',
        margin: '0 auto',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      children: [
        {
          id: generateId(),
          type: 'image' as ElementType,
          src: img,
          alt: title,
          styles: {
            width: title === '1 Month Supply' ? '80%' : '100%',
            height: title === '1 Month Supply' ? '80%' : '100%',
            objectFit: 'contain',
            maxWidth: '100%',
            maxHeight: '100%',
          },
        },
      ],
    },
    // Features List
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '100%',
        marginTop:
          title === '6-Month Package'
            ? '0'
            : title === '1 Month Supply'
            ? '10px'
            : '5px',
      },
      children: [
        {
          id: generateId(),
          type: 'list' as ElementType,
          styles: {
            width: 'max-content',
            margin: '0 auto',
            padding: '0',
            listStyle: 'none',
          },
          children: features.map((feature: string) => ({
            id: generateId(),
            type: 'listItem' as ElementType,
            content: `<span style="color:#CF178F"><i class="fa-solid fa-check"></i></span> ${feature}`,
            styles: {
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              fontSize: '20px',
              fontWeight: '400',
              color: 'forground',
              lineHeight: '150%',
            },
          })),
        },
      ],
    },
    // Price
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: { marginTop: '19px', textAlign: 'center' },
      children: [
        {
          id: generateId(),
          type: 'paragraph' as ElementType,
          content: 'BOTTLE PRICE:',
          styles: {
            fontSize: '16px',
            fontWeight: '700',
            color: 'tertiary',
            textAlign: 'center',
            margin: '0',
          },
        },
        {
          id: generateId(),
          type: 'heading' as ElementType,
          content: price,
          styles: {
            fontSize: '58px',
            fontWeight: '700',
            color: '#CF178F',
            height: '82px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0',
          },
        },
      ],
    },
    // Order Button
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        marginTop: '19px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      },
      children: [
        {
          id: generateId(),
          type: 'link' as ElementType,
          href: orderLink,
          content: orderText,
          styles: {
            display: 'block',
            fontWeight: '700',
            fontSize: '20px',
            borderRadius: '24px',
            padding: '10.5px 27.5px',
            backgroundColor:
              orderBtnClass === 'secondary' ? '#E6E6E6' : '#F4B83D',
            color: orderBtnClass === 'secondary' ? 'forground' : 'forground',
            textDecoration: 'none',
            textTransform: 'capitalize',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            width: title === '6-Month Package' ? '224px' : '100%',
            textAlign: 'center',
          },
          typography: 'Button',
        },
        touchIcon
          ? {
              id: generateId(),
              type: 'image' as ElementType,
              src: touchIcon,
              alt: 'Touch Icon',
              styles: {
                position: 'absolute',
                width: '54px',
                right: '46px',
                bottom: '-23px',
              },
            }
          : null,
      ].filter(Boolean),
    },
    // Certifications
    ...(certifications && certifications.length
      ? [
          {
            id: generateId(),
            type: 'container' as ElementType,
            styles: {
              marginTop: '18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4.5px',
            },
            children: certifications.map((src: string) => ({
              id: generateId(),
              type: 'container' as ElementType,
              styles: { width: '71.308px', height: '68px' },
              children: [
                {
                  id: generateId(),
                  type: 'image' as ElementType,
                  src,
                  alt: 'Certification',
                  styles: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  },
                },
              ],
            })),
          },
        ]
      : []),
    // Secure Payment (only for 6-Month Package)
    ...(title === '6-Month Package' && paymentOptions
      ? [
          {
            id: generateId(),
            type: 'container' as ElementType,
            styles: {
              marginTop: '11px',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: '5px',
            },
            children: [
              {
                id: generateId(),
                type: 'heading' as ElementType,
                content:
                  'Safe & Secure <span>checkout</span> <i class="fa-solid fa-lock"></i>',
                styles: {
                  fontSize: '18px',
                  fontWeight: '700',
                  color: '#CF178F',
                  gap: '5px',
                  textAlign: 'center',
                },
                responsiveStyles: {
                  tablet: { fontSize: '10px', lineHeight: '16px' },
                  mobile: { fontSize: '8px', lineHeight: '12px' },
                },
              },
              {
                id: generateId(),
                type: 'image' as ElementType,
                src: paymentOptions,
                alt: 'Payment Options',
                styles: { width: '100%', height: 'auto', objectFit: 'contain' },
              },
            ],
          },
        ]
      : []),
    // Total Price
    ...(totalPrice
      ? [
          {
            id: generateId(),
            type: 'paragraph' as ElementType,
            content: `Total Price = ${totalPrice}`,
            styles: {
              fontSize: '18px',
              fontWeight: '400',
              color: '#333333',
              textAlign: 'center',
              marginTop: '10px',
            },
            typography: 'Body',
          },
        ]
      : []),
  ];

  const mobileChildren = [
    // Left Column (Image + Certifications/Payment)
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      responsiveStyles: {
        tablet: { display: 'flex' },
        mobile: { display: 'flex', maxWidth: '48%' },
      },
      children: [
        // Guarantee (only for 6-Month Package)
        ...(guarantee
          ? [
              {
                id: generateId(),
                type: 'container' as ElementType,
                styles: {
                  width: '171.215px',
                  height: '153.319px',
                  margin: '0 auto',
                  marginBottom: '-80px',
                  zIndex: '2',
                  position: 'absolute',
                  top: '-103px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                },
                responsiveStyles: {
                  tablet: { width: '152px', height: '152px', top: '-103px' },
                  mobile: { width: '80px', height: '80px', top: '-60px' },
                },
                children: [
                  {
                    id: generateId(),
                    type: 'image' as ElementType,
                    src: guarantee,
                    alt: 'Guarantee',
                    styles: {
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    },
                  },
                ],
              },
            ]
          : []),
        // Title (Mobile/Tablet only)
        {
          id: generateId(),
          type: 'heading' as ElementType,
          content: title,
          styles: {
            display: 'none',
            fontSize: '30px',
            fontWeight: '700',
            color: 'forground',
            textAlign: 'center',
            paddingBottom: '13px',
          },
          responsiveStyles: {
            tablet: { display: 'block' },
            mobile: {
              display: 'block',
              fontSize: '16px',
              paddingBottom: '8px',
            },
          },
        },
        // Product Image
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            width: '100%',
            height: title === '6-Month Package' ? '303px' : '221px',
            margin: '0 auto',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          responsiveStyles: {
            tablet: { height: title === '6-Month Package' ? '303px' : '150px' },
            mobile: { height: title === '6-Month Package' ? '120px' : '80px' },
          },
          children: [
            {
              id: generateId(),
              type: 'image' as ElementType,
              src: img,
              alt: title,
              styles: {
                width: title === '1 Month Supply' ? '80%' : '100%',
                height: title === '1 Month Supply' ? '80%' : '100%',
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%',
              },
            },
          ],
        },
        // Certifications (for 1 Month and 3 Month)
        ...(title !== '6-Month Package' &&
        certifications &&
        certifications.length
          ? [
              {
                id: generateId(),
                type: 'container' as ElementType,
                styles: {
                  marginTop: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4.5px',
                },
                responsiveStyles: { mobile: { marginTop: '8px', gap: '2px' } },
                children: certifications.map((src: string) => ({
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: { width: '71.308px', height: '68px' },
                  responsiveStyles: {
                    tablet: { width: '50px', height: '50px' },
                    mobile: { width: '25px', height: '25px' },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'image' as ElementType,
                      src,
                      alt: 'Certification',
                      styles: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      },
                    },
                  ],
                })),
              },
            ]
          : []),
        // Secure Payment (only for 6-Month Package)
        ...(title === '6-Month Package' && paymentOptions
          ? [
              {
                id: generateId(),
                type: 'container' as ElementType,
                styles: {
                  marginTop: '11px',
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: '5px',
                },
                responsiveStyles: { mobile: { marginTop: '6px', gap: '2px' } },
                children: [
                  {
                    id: generateId(),
                    type: 'heading' as ElementType,
                    content:
                      'Safe & Secure <span>checkout</span> <i class="fa-solid fa-lock"></i>',
                    styles: {
                      fontSize: '18px',
                      fontWeight: '700',
                      color: '#CF178F',
                      gap: '5px',
                      textAlign: 'center',
                    },
                    responsiveStyles: {
                      tablet: { fontSize: '10px', lineHeight: '16px' },
                      mobile: { fontSize: '8px', lineHeight: '12px' },
                    },
                  },
                  {
                    id: generateId(),
                    type: 'image' as ElementType,
                    src: paymentOptions,
                    alt: 'Payment Options',
                    styles: {
                      width: '100%',
                      height: 'auto',
                      objectFit: 'contain',
                    },
                  },
                ],
              },
            ]
          : []),
      ],
    },
    // Right Column (Price + Button + Features)
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      responsiveStyles: {
        tablet: { display: 'flex' },
        mobile: { display: 'flex', maxWidth: '48%' },
      },
      children: [
        // Price
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: { marginTop: '19px' },
          responsiveStyles: { mobile: { marginTop: '8px' } },
          children: [
            {
              id: generateId(),
              type: 'paragraph' as ElementType,
              content: 'BOTTLE PRICE:',
              styles: {
                fontSize: '16px',
                fontWeight: '700',
                color: 'tertiary',
                textAlign: 'center',
              },
              responsiveStyles: {
                tablet: { fontSize: '14px' },
                mobile: { fontSize: '10px' },
              },
            },
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: price,
              styles: {
                fontSize: '58px',
                fontWeight: '700',
                color: '#CF178F',
                height: '82px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              },
              responsiveStyles: {
                tablet: { height: '55px' },
                mobile: { fontSize: '24px', height: '30px' },
              },
            },
          ],
        },
        // Order Button
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            marginTop: '19px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          },
          responsiveStyles: { mobile: { marginTop: '8px' } },
          children: [
            {
              id: generateId(),
              type: 'link' as ElementType,
              href: orderLink,
              content: orderText,
              styles: {
                display: 'block',
                fontWeight: '700',
                fontSize: '20px',
                borderRadius: '24px',
                padding: '10.5px 27.5px',
                backgroundColor:
                  orderBtnClass === 'secondary' ? '#E6E6E6' : '#F4B83D',
                color:
                  orderBtnClass === 'secondary' ? 'forground' : 'forground',
                textDecoration: 'none',
                textTransform: 'capitalize',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                width: title === '6-Month Package' ? '224px' : '100%',
                textAlign: 'center',
              },
              typography: 'Button',
              responsiveStyles: {
                mobile: {
                  padding: title === '6-Month Package' ? '6px 8px' : '6px 12px',
                  fontSize: title === '6-Month Package' ? '12px' : '10px',
                  borderRadius: '12px',
                  width: '100%',
                },
              },
            },
            touchIcon
              ? {
                  id: generateId(),
                  type: 'image' as ElementType,
                  src: touchIcon,
                  alt: 'Touch Icon',
                  styles: {
                    position: 'absolute',
                    width: '54px',
                    right: '46px',
                    bottom: '-23px',
                  },
                  responsiveStyles: {
                    mobile: { width: '20px', right: '8px', bottom: '-10px' },
                  },
                }
              : null,
          ].filter(Boolean),
        },
        // Features List
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: { width: '100%', marginTop: '16px' },
          responsiveStyles: { mobile: { marginTop: '6px' } },
          children: [
            {
              id: generateId(),
              type: 'list' as ElementType,
              styles: {
                width: 'max-content',
                margin: '0 auto',
                padding: '0',
                listStyle: 'none',
              },
              responsiveStyles: { mobile: { marginTop: '4px' } },
              children: features.map((feature: string) => ({
                id: generateId(),
                type: 'listItem' as ElementType,
                content: `<span style="color:#CF178F"><i class="fa-solid fa-check"></i></span> ${feature}`,
                styles: {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0',
                  fontSize: '12px',
                  fontWeight: '400',
                  color: 'forground',
                  lineHeight: '150%',
                },
              })),
            },
          ],
        },
      ],
    },
  ];

  return {
    id: generateId(),
    type: 'container' as ElementType,
    styles: {
      width: '364px',
      border:
        title === '6-Month Package' ? '3px solid #D9D9D9' : '2px solid #E5E7EB',
      borderRadius: '20px',
      backgroundImage:
        title === '6-Month Package'
          ? 'linear-gradient(180deg, #FFF 0%, #4CC8EE 100%)'
          : '#F9FAFB',
      padding: `${
        title === '6-Month Package'
          ? '50px 32px 23px'
          : title === '1 Month Supply'
          ? '95px 23px 52px'
          : '85px 32px 23px'
      }`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      boxShadow:
        title === '6-Month Package'
          ? '0px 4px 54px 30px rgba(255, 197, 61, 0.05)'
          : 'none',
    },
    responsiveStyles: {
      tablet: {
        width: '100%',
        padding:
          title === '6-Month Package'
            ? '50px 32px 23px'
            : title === '1 Month Supply'
            ? '34px 13px 20px'
            : '34px 8px 21px',
        order:
          title === '6-Month Package' ? 1 : title === '1 Month Supply' ? 2 : 3,
      },
      mobile: {
        width: '100%',
        padding:
          title === '6-Month Package'
            ? '40px 8px 16px'
            : title === '1 Month Supply'
            ? '25px 8px 15px'
            : '25px 8px 15px',
        order:
          title === '6-Month Package' ? 1 : title === '1 Month Supply' ? 2 : 3,
        borderRadius: '12px',
      },
    },
    children: [
      // Desktop View
      {
        id: generateId(),
        type: 'container' as ElementType,
        styles: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        },
        responsiveStyles: {
          tablet: { display: 'none' },
          mobile: { display: 'none' },
        },
        children: desktopChildren,
      },
      // Mobile & Tablet View
      {
        id: generateId(),
        type: 'container' as ElementType,
        styles: {
          display: 'none',
        },
        responsiveStyles: {
          tablet: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: '24px',
          },
          mobile: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: '4px',
          },
        },
        children: mobileChildren,
      },
    ],
  };
}

const createServicesSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    padding: '72px 0 115px',
    backgroundColor: 'background',
    width: '100%',
  },
  responsiveStyles: {
    tablet: {
      padding: '50px 0 80px',
    },
    mobile: {
      padding: '40px 0 60px',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1270px',
        maxWidth: '1270px',
        margin: '0 auto',
        padding: '0 30px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '0 20px',
        },
        mobile: {
          maxWidth: '100%',
          padding: '0 16px',
        },
      },
      children: [
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '24px',
          },
          responsiveStyles: {
            tablet: {
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '20px',
            },
            mobile: {
              flexDirection: 'column',
              gap: '16px',
            },
          },
          children: [
            ...[
              {
                icon: '/images/movyo/service1.webp',
                desc: '<span>Crafted with care</span> to support your unique health needs.',
              },
              {
                icon: '/images/movyo/service2.webp',
                desc: '<span>100% vegan</span> and <span>cruelty-free</span> MOVYO for a healthier you.',
              },
              {
                icon: '/images/movyo/service3.webp',
                desc: '<span>Science-backed</span> MOVYO for optimal health and wellness.',
              },
              {
                icon: '/images/movyo/service4.webp',
                desc: '<span>Experience the difference</span> with our next-level supplement.',
              },
            ].map((item) => ({
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                width: '300px',
                height: '290px',
                padding: '24px 32px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '32px',
                borderRadius: '16px',
                boxShadow: '5px 4px 100px 5px rgba(0, 0, 0, 0.05)',
                backgroundColor: 'background',
              },
              responsiveStyles: {
                tablet: {
                  width: '100%',
                  maxWidth: '400px',
                  height: 'auto',
                  minHeight: '200px',
                  padding: '20px 24px',
                  gap: '24px',
                },
                mobile: {
                  width: '100%',
                  height: 'auto',
                  minHeight: '180px',
                  padding: '16px 20px',
                  gap: '20px',
                },
              },
              children: [
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    width: '50px',
                    height: '50px',
                  },
                  responsiveStyles: {
                    tablet: {
                      width: '40px',
                      height: '40px',
                    },
                    mobile: {
                      width: '35px',
                      height: '35px',
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'image' as ElementType,
                      src: item.icon,
                      alt: 'Services Icon',
                      styles: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {},
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content: item.desc,
                      styles: {
                        fontSize: '20px',
                        fontWeight: '400',
                        lineHeight: '24px',
                        letterSpacing: '0.2px',
                        color: 'forground',
                        textAlign: 'center',
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: '18px',
                          lineHeight: '22px',
                        },
                        mobile: {
                          fontSize: '16px',
                          lineHeight: '20px',
                        },
                      },
                    },
                  ],
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

const createExclusiveBonusesSection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: 'container' as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: 'background',
    width: '100%',
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1270px',
        maxWidth: '1270px',
        margin: '0 auto',
        padding: '0 30px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '0 20px',
        },
        mobile: {
          maxWidth: '100%',
          padding: '0 16px',
        },
      },
      children: [
        // Title and subtitle
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            maxWidth: '1200px',
            margin: '0 auto',
            textAlign: 'center',
            padding: '72px 0 0 0',
          },
          responsiveStyles: {
            tablet: {
              padding: '50px 0 0 0',
            },
            mobile: {
              padding: '40px 0 0 0',
            },
          },
          children: [
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: 'Unlock Exclusive Bonuses – Yours FREE With Your Order!',
              styles: {
                fontSize: '33px',
                fontWeight: '700',
                lineHeight: '49.5px',
                color: 'forground',
                paddingBottom: '24px',
                textShadow: '0px 2px 0px rgba(0, 0, 0, 0.04)',
                margin: 0,
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '28px',
                  lineHeight: '36px',
                  paddingBottom: '20px',
                },
                mobile: {
                  fontSize: '24px',
                  lineHeight: '32px',
                  paddingBottom: '16px',
                },
              },
              typography: 'Heading-4',
            },
            {
              id: generateId(),
              type: 'paragraph' as ElementType,
              content:
                'When you order MOVYO today, you not only get the secret to natural weight loss, you also receive exclusive bonuses designed to supercharge your transformation!',
              styles: {
                fontSize: '20px',
                fontWeight: '400',
                lineHeight: '24px',
                color: 'forground',
                margin: '0',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '18px',
                  lineHeight: '22px',
                },
                mobile: {
                  fontSize: '16px',
                  lineHeight: '20px',
                },
              },
            },
          ],
        },
        // Bonuses content
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '81px',
            marginTop: '24px',
          },
          responsiveStyles: {
            tablet: {
              gap: '20px',
              marginTop: '20px',
            },
            mobile: {
              flexDirection: 'column',
              gap: '30px',
              marginTop: '16px',
            },
          },
          children: [
            // Bonus 1
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '24px',
                width: '294px',
              },
              responsiveStyles: {
                tablet: {
                  width: '100%',
                  maxWidth: '400px',
                  gap: '20px',
                },
                mobile: {
                  width: '100%',
                  gap: '16px',
                },
              },
              children: [
                // Image + Badge
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    width: '294px',
                    height: '294px',
                    borderRadius: '20px',
                    overflow: 'hidden',
                    position: 'relative',
                  },
                  responsiveStyles: {
                    tablet: {
                      width: '100%',
                      maxWidth: '300px',
                      height: 'auto',
                      aspectRatio: '1/1',
                    },
                    mobile: {
                      width: '100%',
                      maxWidth: '250px',
                      height: 'auto',
                      aspectRatio: '1/1',
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'image' as ElementType,
                      src: '/images/movyo/bonuse1.webp',
                      alt: 'Bonus 1',
                      styles: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        position: 'absolute',
                        bottom: '8px',
                        right: '8.5px',
                        width: '52px',
                        height: '52px',
                      },
                      responsiveStyles: {
                        tablet: {
                          width: '40px',
                          height: '40px',
                        },
                        mobile: {
                          width: '35px',
                          height: '35px',
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/digitalBadge.webp',
                          alt: 'Bonus 1 Badge',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          },
                        },
                      ],
                    },
                  ],
                },
                // Title and description
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'heading' as ElementType,
                      content: 'Love Your Body Again <br>30-Day Reset Guide',
                      styles: {
                        fontSize: '20px',
                        fontWeight: '700',
                        lineHeight: '24px',
                        color: 'forground',
                        margin: 0,
                      },
                      typography: 'Button',
                      responsiveStyles: {
                        tablet: {
                          fontSize: '18px',
                          lineHeight: '22px',
                        },
                        mobile: {
                          fontSize: '16px',
                          lineHeight: '20px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'This guide provides a simple, step-by-step plan to jumpstart your weight loss journey. Enjoy practical tips and easy routines to transform your body from day one.',
                      styles: {
                        fontSize: '20px',
                        fontWeight: '400',
                        lineHeight: '24px',
                        color: 'forground',
                        margin: '0',
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: '16px',
                          lineHeight: '20px',
                        },
                        mobile: {
                          fontSize: '14px',
                          lineHeight: '18px',
                        },
                      },
                    },
                  ],
                },
                // Amount
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {},
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        '<span style="text-decoration:line-through;">$47</span> Today: <span style="color:#D4339C;">FREE</span>',
                      styles: {
                        color: 'tertiary',
                        fontSize: '28px',
                        fontWeight: '700',
                        lineHeight: '24px',
                        textAlign: 'center',
                        margin: '0',
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: '24px',
                          lineHeight: '20px',
                        },
                        mobile: {
                          fontSize: '20px',
                          lineHeight: '18px',
                        },
                      },
                      typography: 'Heading-5',
                    },
                  ],
                },
              ],
            },
            // Bonus 2
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '24px',
                width: '294px',
              },
              responsiveStyles: {
                tablet: {
                  width: '100%',
                  maxWidth: '400px',
                  gap: '20px',
                },
                mobile: {
                  width: '100%',
                  gap: '16px',
                },
              },
              children: [
                // Image + Badge
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    width: '294px',
                    height: '294px',
                    borderRadius: '20px',
                    overflow: 'hidden',
                    position: 'relative',
                  },
                  responsiveStyles: {
                    tablet: {
                      width: '100%',
                      maxWidth: '300px',
                      height: 'auto',
                      aspectRatio: '1/1',
                    },
                    mobile: {
                      width: '100%',
                      maxWidth: '250px',
                      height: 'auto',
                      aspectRatio: '1/1',
                    },
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'image' as ElementType,
                      src: '/images/movyo/bonuse2.webp',
                      alt: 'Bonus 2',
                      styles: {
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      },
                    },
                    {
                      id: generateId(),
                      type: 'container' as ElementType,
                      styles: {
                        position: 'absolute',
                        bottom: '8px',
                        right: '5px',
                        width: '52px',
                        height: '52px',
                      },
                      responsiveStyles: {
                        tablet: {
                          width: '40px',
                          height: '40px',
                        },
                        mobile: {
                          width: '35px',
                          height: '35px',
                        },
                      },
                      children: [
                        {
                          id: generateId(),
                          type: 'image' as ElementType,
                          src: '/images/movyo/digitalBadge2.webp',
                          alt: 'Bonus 2 Badge',
                          styles: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          },
                        },
                      ],
                    },
                  ],
                },
                // Title and description
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {
                    textAlign: 'center',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'heading' as ElementType,
                      content: 'Forever Fit <br>The Alpine Secret Guide',
                      styles: {
                        fontSize: '20px',
                        fontWeight: '700',
                        lineHeight: '24px',
                        color: 'forground',
                        margin: 0,
                      },
                      typography: 'Button',
                      responsiveStyles: {
                        tablet: {
                          fontSize: '18px',
                          lineHeight: '22px',
                        },
                        mobile: {
                          fontSize: '16px',
                          lineHeight: '20px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        'Discover key strategies to maintain energy, vitality, and a slim figure. Learn timeless French Alpine wisdom for sustainable, lasting results.',
                      styles: {
                        fontSize: '20px',
                        fontWeight: '400',
                        lineHeight: '24px',
                        color: 'forground',
                        margin: '0',
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: '16px',
                          lineHeight: '20px',
                        },
                        mobile: {
                          fontSize: '14px',
                          lineHeight: '18px',
                        },
                      },
                    },
                  ],
                },
                // Amount
                {
                  id: generateId(),
                  type: 'container' as ElementType,
                  styles: {},
                  children: [
                    {
                      id: generateId(),
                      type: 'paragraph' as ElementType,
                      content:
                        '<span style="text-decoration:line-through;">$100</span> Today: <span style="color:#D4339C;">FREE</span>',
                      styles: {
                        color: 'tertiary',
                        fontSize: '28px',
                        fontWeight: '700',
                        lineHeight: '24px',
                        textAlign: 'center',
                        margin: '0',
                      },
                      typography: 'Heading-5',
                      responsiveStyles: {
                        tablet: {
                          fontSize: '24px',
                          lineHeight: '20px',
                        },
                        mobile: {
                          fontSize: '20px',
                          lineHeight: '18px',
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createOffersSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    backgroundColor: 'forground',
    padding: '60px 30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  responsiveStyles: {
    tablet: {
      padding: '40px 20px',
    },
    mobile: {
      padding: '30px 16px',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1270px',
        maxWidth: '1270px',
        textAlign: 'center',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
        },
        mobile: {
          maxWidth: '100%',
        },
      },
      children: [
        {
          id: generateId(),
          type: 'heading' as ElementType,
          content:
            "Introducing MOVYO. A revolutionary, science-backed capsule that captures a 5-second morning secret from the French Alps. It naturally awakens your body's own fat-burning hormone, GLP-1, so you can finally lose weight without starving yourself.",
          styles: {
            fontSize: '28px',
            fontWeight: '600',
            color: 'background',
            margin: '0 0 40px 0',
            lineHeight: '1.4',
          },
          responsiveStyles: {
            tablet: {
              fontSize: '24px',
              margin: '0 0 30px 0',
              lineHeight: '1.3',
            },
            mobile: {
              fontSize: '20px',
              margin: '0 0 25px 0',
              lineHeight: '1.3',
            },
          },
        },
        {
          id: generateId(),
          type: 'button' as ElementType,
          content: 'Movyo offering a massive discount, get yours now!',
          styles: {
            backgroundColor: '#F4B83D',
            color: 'forground',
            padding: '16px 24px',
            borderRadius: '24px',
            fontWeight: '700',
            fontSize: '20px',
            lineHeight: '24px',
            cursor: 'pointer',
            border: 'none',
            textTransform: 'capitalize',
            transition: 'all 0.3s ease',
          },
          typography: 'Button',
          responsiveStyles: {
            tablet: {
              padding: '14px 20px',
              fontSize: '18px',
              lineHeight: '22px',
            },
            mobile: {
              padding: '12px 18px',
              fontSize: '16px',
              lineHeight: '20px',
            },
          },
        },
      ],
    },
  ],
});

const createFAQSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    padding: '93px 80px 0',
    backgroundColor: 'background',
    width: '100%',
  },
  responsiveStyles: {
    tablet: {
      padding: '60px 40px 0',
    },
    mobile: {
      padding: '40px 16px 0',
    },
  },
  children: [
    // Section Title
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        textAlign: 'center',
        marginBottom: '32px',
      },
      responsiveStyles: {
        tablet: {
          marginBottom: '24px',
        },
        mobile: {
          marginBottom: '20px',
        },
      },
      children: [
        {
          id: generateId(),
          type: 'heading' as ElementType,
          content: 'Frequently Asked Questions ',
          styles: {
            fontFamily: 'Inter',
            fontWeight: '700',
            fontSize: '40px',
            lineHeight: '150%',
            textAlign: 'center',
            color: 'forground',
          },
          responsiveStyles: {
            tablet: {
              fontSize: '32px',
              lineHeight: '120%',
            },
            mobile: {
              fontSize: '28px',
              lineHeight: '120%',
            },
          },
          typography: 'Heading-2',
        },
      ],
    },
    {
      id: generateId(),
      type: 'accordion' as ElementType,
      allowMultiple: false,
      defaultOpen: false,
      accordionType: 'single' as 'single' | 'multiple',
      // Icon configuration for all accordion items
      iconSrcCollapsed: '/fortigold/arrow-right-circle.svg',
      iconSrcExpanded: '/fortigold/arrow-right-circle.svg',
      // Icon styling
      iconStyles: {
        width: '46px',
        height: '47px',
        marginLeft: '16px',
      },
      styles: {
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        border: '0',
      },
      responsiveStyles: {
        tablet: { maxWidth: '95%' },
        mobile: { maxWidth: '100%' },
      },
      children: [
        // FAQ Items
        ...[
          {
            q: 'What is MOVYO?',
            a: 'MOVYO is a natural weight loss capsule inspired by French Alpine traditions. It helps your body boost metabolism and burn fat without extreme diets or harsh chemicals.',
          },
          {
            q: 'How does MOVYO work?',
            a: 'It helps activate your body’s natural fat-burning process by promoting the production of essential metabolic hormones. This gentle formula helps you shed stubborn fat naturally.',
          },
          {
            q: 'Who is MOVYO for?',
            a: 'MOVYO is designed for anyone tired of expensive, ineffective weight loss solutions. It’s perfect for those seeking a natural, sustainable method to boost energy and lose weight.',
          },
          {
            q: 'How soon can I expect results?',
            a: 'Many users report increased energy within weeks and visible weight loss improvements in a couple of months. Consistent daily use helps your body gradually transform over time.',
          },
          {
            q: 'Are there any side effects?',
            a: 'MOVYO is formulated with natural, research-backed ingredients and is gentle on your body. Most users experience no adverse effects while enjoying its benefits.',
          },
          {
            q: 'How should I take MOVYO?',
            a: 'Simply take one capsule each morning with a glass of water before breakfast. This easy, 5-second routine kick-starts your metabolism for the day ahead.',
          },
          {
            q: 'Can I use MOVYO with other supplements?',
            a: 'Yes, MOVYO is designed to complement your current health routine. It works in harmony with other supplements to support your natural weight loss journey.',
          },
          {
            q: 'Is there a money-back guarantee?',
            a: 'Absolutely if you’re not satisfied, our 60-day money-back guarantee ensures a risk-free experience. You can try MOVYO with confidence knowing your purchase is protected.',
          },
          {
            q: 'What makes MOVYO different from other weight loss products?',
            a: 'MOVYO leverages time-tested French Alpine wisdom to naturally helps restore your body’s weight control system. Unlike temporary fixes, it offers a sustainable solution that works in harmony with your body.',
          },
        ].map((item, idx) => ({
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            padding: '0',
            marginBottom: '32px',
            transition: 'transform 0.2s cubic-bezier(.4,0,.2,1)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            gap: '32px ',
            width: '100%',
            border: '0',
          },
          responsiveStyles: {
            tablet: {
              marginBottom: '0px',
              padding: '24px 16px',
              gap: '24px',
            },
            mobile: {
              marginBottom: '0px',
              padding: '6px 16px',
              gap: '18px',
            },
          },
          children: [
            // Question row
            {
              id: generateId(),
              type: 'heading' as ElementType,
              accordionRole: 'question' as const,
              content: item.q,
              styles: {
                margin: 0,
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 600,
                fontSize: '24px',
                color: '#393939',
                padding: '0px 24px',
                backgroundColor: '#F7F7F7',
                border: '1px solid #E0E0E0',
                borderRadius: '16px',
                minHeight: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '18px',
                  minHeight: '80px',
                  padding: '0px 16px',
                  lineHeight: '22px',
                },
                mobile: {
                  fontSize: '16px',
                  lineHeight: '20px',
                  letterSpacing: '-0.54px',
                  minHeight: '80px',
                  padding: '0px 12px',
                },
              },
            },
            // Answer (hidden by default, to be toggled by UI logic)
            {
              id: generateId(),
              type: 'paragraph' as ElementType,
              accordionRole: 'answer' as const,
              content: item.a,
              styles: {
                margin: 0,
                fontFamily: 'Poppins, sans-serif',
                fontSize: '16px',
                color: 'rgba(0,0,0,0.60)',
                width: '100%',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '14px',
                  lineHeight: '20px',
                },
                mobile: {
                  fontSize: '12px',
                  lineHeight: '18px',
                },
              },
            },
          ],
        })),
      ],
    },
  ],
});

const createMentionedInSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    width: '100%',
    maxWidth: '1440px',
    margin: '0 auto',
    padding: '80px 30px',
    backgroundColor: 'background',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '40px',
  },
  responsiveStyles: {
    tablet: {
      padding: '60px 20px',
      gap: '30px',
    },
    mobile: {
      padding: '40px 16px',
      gap: '25px',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'heading' as ElementType,
      content: 'Mentioned in',
      styles: {
        fontFamily: 'Inter',
        fontWeight: '700',
        fontSize: '40px',
        lineHeight: '150%',
        textAlign: 'center',
        color: 'forground',
        margin: '0',
        padding: '0',
      },
      responsiveStyles: {
        tablet: {
          fontSize: '32px',
          lineHeight: '120%',
        },
        mobile: {
          fontSize: '28px',
          lineHeight: '120%',
        },
      },
      typography: 'Heading-2',
    },
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '40px',
        width: '100%',
        flexWrap: 'wrap',
      },
      responsiveStyles: {
        tablet: {
          gap: '30px',
        },
        mobile: {
          gap: '20px',
        },
      },
      children: [
        {
          id: generateId(),
          type: 'image' as ElementType,
          src: '/images/movyo/mentioned1.webp',
          alt: 'The Lancet Logo',
          styles: {
            width: '150px',
            height: 'auto',
            objectFit: 'contain',
          },
          responsiveStyles: {
            tablet: {
              width: '120px',
            },
            mobile: {
              width: '100px',
            },
          },
        },
        {
          id: generateId(),
          type: 'image' as ElementType,
          src: '/images/movyo/mentioned2.webp',
          alt: 'Harvard Health Publishing Logo',
          styles: {
            width: '200px',
            height: 'auto',
            objectFit: 'contain',
          },
          responsiveStyles: {
            tablet: {
              width: '160px',
            },
            mobile: {
              width: '130px',
            },
          },
        },
        {
          id: generateId(),
          type: 'image' as ElementType,
          src: '/images/movyo/mentioned3.webp',
          alt: 'ESC European Society of Cardiology Logo',
          styles: {
            width: '150px',
            height: 'auto',
            objectFit: 'contain',
          },
          responsiveStyles: {
            tablet: {
              width: '120px',
            },
            mobile: {
              width: '100px',
            },
          },
        },
        {
          id: generateId(),
          type: 'image' as ElementType,
          src: '/images/movyo/mentioned4.webp',
          alt: 'The BMJ British Medical Journal Logo',
          styles: {
            width: '100px',
            height: 'auto',
            objectFit: 'contain',
          },
          responsiveStyles: {
            tablet: {
              width: '80px',
            },
            mobile: {
              width: '70px',
            },
          },
        },
      ],
    },
  ],
});

const createPartnerMenuSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    backgroundColor: '#FAFAFA',
    width: '100%',
  },
  responsiveStyles: {
    mobile: {
      margin: '0 0 16px',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1270px',
        maxWidth: '1270px',
        margin: '0 auto',
        padding: '40px 30px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '30px 20px',
        },
        mobile: {
          maxWidth: '100%',
          padding: '20px 15px',
        },
      },
      children: [
        // Partner Menu Title
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            textAlign: 'center',
          },
          children: [
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: 'Scientific References:',
              styles: {
                fontSize: '40px',
                fontWeight: '700',
                lineHeight: '150%',
                color: 'forground',
                margin: '0',
                textAlign: 'center',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '32px',
                },
                mobile: {
                  fontSize: '24px',
                },
              },
              typography: 'Heading-2',
            },
          ],
        },
        // Partner Menu Content
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            textAlign: 'center',
            maxWidth: '557.966px',
            margin: '32px auto 0',
          },
          responsiveStyles: {
            mobile: {
              margin: '10px auto 0',
            },
          },
          children: [
            {
              id: generateId(),
              type: 'image' as ElementType,
              src: '/images/movyo/partnerMenu.webp',
              alt: 'Partner Menu',
              styles: {
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              },
            },
          ],
        },
      ],
    },
  ],
});

const createListingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    padding: '43px 0 27px',
    backgroundColor: '#FAFAFA',
    width: '100%',
  },
  responsiveStyles: {
    mobile: {
      margin: '0 0 16px',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        width: '1270px',
        maxWidth: '1270px',
        margin: '0 auto',
        padding: '0 30px',
      },
      responsiveStyles: {
        tablet: {
          maxWidth: '100%',
          padding: '0 20px',
        },
        mobile: {
          maxWidth: '100%',
          padding: '0 15px',
        },
      },
      children: [
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: '65px',
          },
          responsiveStyles: {
            tablet: {
              flexDirection: 'column',
              gap: '16px',
              padding: '0 25px',
            },
            mobile: {
              flexDirection: 'column',
              gap: '16px',
              padding: '0 25px',
            },
          },
          children: [
            // First Column
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flex: '1',
              },
              children: [
                {
                  id: generateId(),
                  type: 'list' as ElementType,
                  styles: {
                    listStyle: 'decimal',
                    padding: '0',
                    margin: '0',
                    width: '100%',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Akbar A, Shreenath AP. High Fiber Diet. Treasure Island (FL): StatPearls Publishing; 2024 Jan.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Bonaz B, Sinniger V, Pellissier S. Therapeutic potential of vagus nerve stimulation for inflammatory bowel diseases. Frontiers in Neuroscience. 2021 Mar 22;15:650971. doi:10.3389/fnins.2021.650971.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Cerritelli F, Frasch MG, Antonelli MC, Viglione C, Vecchi S, Chiera M, Manzotti A. A review on the vagus nerve and autonomic nervous system during fetal development: searching for critical windows. Frontiers in Neuroscience. 2021 Sep 20;15:721605. doi:10.3389/fnins.2021.721605.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Chen HL, Cheng HC, Wu WT, Liu YJ, Liu SY. Supplementation of konjac glucomannan into a low-fiber Chinese diet promoted bowel movement and improved colonic ecology in constipated adults: a placebo-controlled, diet-controlled trial. Journal of the American College of Nutrition. 2008 Feb 1;27(1):102-108. doi:10.1080/07315724.2008.10719681.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Cleveland Clinic. The gut-brain connection [Internet]. 2023 [cited 2024 Mar 29].',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Coe SA, Clegg M, Armengol M, Ryan L. The polyphenol-rich baobab fruit (Adansonia digitata L.) reduces starch digestion and glycemic response in humans. Nutrition Research. 2013 Nov;33(11):888-896. doi:10.1016/j.nutres.2013.08.002.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Devaraj RD, Reddy CK, Xu B. Health-promoting effects of konjac glucomannan and its practical applications: A critical review. International Journal of Biological Macromolecules. 2019 Apr 1;126:273-281. doi:10.1016/j.ijbiomac.2018.12.203.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Garvey R, Clegg M, Coe S. The acute effects of baobab fruit (Adansonia digitata) on satiety in healthy adults. Nutrition and Health. 2017 Jun;23(2):83-86. doi:10.1177/0260106017704361.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Cherney K. What Are the Symptoms of Laxative Withdrawal? [Internet]. Healthline Media; 2023 [cited 2024 Mar 29].',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                  ],
                },
              ],
            },
            // Second Column
            {
              id: generateId(),
              type: 'container' as ElementType,
              styles: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flex: '1',
              },
              children: [
                {
                  id: generateId(),
                  type: 'list' as ElementType,
                  styles: {
                    listStyle: 'decimal',
                    padding: '0',
                    margin: '0',
                    width: '100%',
                    counterReset: 'list-counter 9',
                  },
                  children: [
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Gibson GR, Hutkins R, Sanders ME, Prescott SL, Reimer RA, Salminen SJ, Scott K, Stanton C, Swanson KS, Cani PD, Verbeke K, Reid G. Expert consensus document: The International Scientific Association for Probiotics and Prebiotics (ISAPP) consensus statement on the definition and scope of prebiotics. Nature Reviews Gastroenterology & Hepatology. 2017 Aug;14(8):491-502. doi:10.1038/nrgastro.2017.75.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Han Y, Zhang L, Liu XQ, Zhao ZJ, Lv LX. Effect of glucomannan on functional constipation in children: a systematic review and meta-analysis of randomized controlled trials. Asia Pacific Journal of Clinical Nutrition. 2017 May;26(3):471-477. doi:10.6133/apjcn.032016.03.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Ma L, Ni Y, Wang Z, Tu W, Ni L, Zhuge F, Zheng A, Hu L, Zhao Y, Zheng L, Fu Z. Spermidine improves gut barrier integrity and gut microbiota function in diet-induced obese mice. Gut Microbes. 2020 Nov 9;12(1):1-19. doi:10.1080/19490976.2020.1832857.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'The Ruth Law Team. Common Fluoroquinolone antibiotics cause nerve damage [Internet]. [cited 2024 Mar 29].',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Wilcox H, Carr C, Seney S, Reid G, Burton JP. Expired probiotics: what is really in your cabinet?. FEMS Microbes. 2020 Sep;1(1):xtaa007. doi:10.21203/rs.3.rs-34777/v1.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Wu DT, Li WX, Wan JJ, Hu YC, Gan RY, Zou L. A Comprehensive Review of Pea (Pisum sativum L.): Chemical Composition, Processing, Health Benefits, and Food Applications. Foods. 2023 Jun 29;12(13):2527. doi:10.3390/foods12132527.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Yan B, Mao X, Hu S, Wang S, Liu X, Sun J. Spermidine protects intestinal mucosal barrier function in mice colitis via the AhR/Nrf2 and AhR/STAT3 signaling pathways. International Immunopharmacology. 2023 Jun 1;119:110166. doi:10.1016/j.intimp.2023.110166.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: 'listItem' as ElementType,
                      content:
                        'Yu K, Ke MY, Li WH, Zhang SQ, Fang XC. The impact of soluble dietary fiber on gastric emptying, postprandial blood glucose, and insulin in patients with type 2 diabetes. Asia Pacific Journal of Clinical Nutrition. 2014;23(2):210-218. doi:10.6133/apjcn.2014.23.2.01.',
                      styles: {
                        color: '#333333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '28px',
                        letterSpacing: '-0.2px',
                        marginBottom: '16px',
                      },
                      typography: 'Default',
                      responsiveStyles: {
                        mobile: {
                          fontSize: '14px',
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

// ====================== Footer Menu Section ======================
const createFooterMenuSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    backgroundColor: 'forground',
    padding: '20px 0',
    width: '100%',
  },
  responsiveStyles: {
    tablet: {
      padding: '16px 0',
    },
    mobile: {
      padding: '12px 0',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        maxWidth: '1124px',
        margin: '0 auto',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '32px',
        flexWrap: 'wrap',
      },
      responsiveStyles: {
        tablet: {
          gap: '20px',
          padding: '0 20px',
        },
        mobile: {
          gap: '16px',
          padding: '0 16px',
          flexDirection: 'column',
        },
      },
      children: [
        ...[
          { text: 'Privacy', href: '/privacy-policy' },
          { text: 'Terms & Conditions', href: '/terms-and-conditions' },
          { text: 'Disclaimer', href: '/disclaimer' },
          {
            text: 'Product Label',
            href: '#',
            id: 'product-label-link',
            type: 'popup',
            triggerPopup: 'movyo-label',
          },
          { text: 'Returns & Refunds', href: '/returns-and-refunds' },
          { text: 'Contact', href: '/contact-us' },
        ].map((link) => ({
          id: generateId(),
          type: 'container' as ElementType,
          styles: {},
          children: [
            {
              id: generateId(),
              type:
                link.type === 'popup'
                  ? ('button' as ElementType)
                  : ('link' as ElementType),
              href: link.href,
              content: link.text,
              ...(link.type === 'popup'
                ? {
                    interactionType: 'popup' as const,
                    triggerPopup: link.triggerPopup,
                  }
                : {
                    href: link.href,
                  }),
              styles: {
                color: 'background',
                textAlign: 'center',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '22px',
                textDecoration: 'none',
                transition: 'color 0.2s',
                cursor: 'pointer',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '13px',
                  lineHeight: '20px',
                },
                mobile: {
                  fontSize: '12px',
                  lineHeight: '18px',
                },
              },
            },
          ],
        })),
      ],
    },
  ],
});

// ====================== Footer End Section ======================
const createFooterEndSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    backgroundColor: 'background',
    width: '100%',
    padding: '15px 0 28px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
  },
  responsiveStyles: {
    tablet: {
      padding: '12px 0 24px',
      gap: '12px',
    },
    mobile: {
      padding: '10px 0 20px',
      gap: '10px',
    },
  },
  children: [
    {
      id: generateId(),
      type: 'paragraph' as ElementType,
      content:
        'Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure or prevent any disease. If you are pregnant, nursing, taking medication, or have a medical condition, consult your physician before using our products.',
      styles: {
        textAlign: 'center',
        color: '#333',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '24px',
        margin: '0',
      },
      typography: 'Default',
      responsiveStyles: {
        tablet: {
          fontSize: '15px',
          lineHeight: '22px',
          padding: '0 20px',
        },
        mobile: {
          fontSize: '14px',
          lineHeight: '20px',
          padding: '0 16px',
        },
      },
    },
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
        maxWidth: '1124px',
      },
      responsiveStyles: {
        tablet: {
          gap: '10px',
          padding: '0 20px',
        },
        mobile: {
          gap: '8px',
          padding: '0 16px',
          flexDirection: 'column',
        },
      },
      children: [
        // Left Logo
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            alignItems: 'center',
          },
          children: [
            {
              id: generateId(),
              type: 'image' as ElementType,
              src: '/images/movyo/Digistore logo.svg',
              alt: 'Logo',
              styles: {
                width: 'auto',
                height: '20px',
                objectFit: 'contain',
              },
              responsiveStyles: {
                tablet: {
                  height: '18px',
                },
                mobile: {
                  height: '16px',
                },
              },
            },
          ],
        },
        // Separator
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            width: '1px',
            height: '20px',
            backgroundColor: '#333',
          },
          responsiveStyles: {
            tablet: {
              height: '18px',
            },
            mobile: {
              display: 'none',
            },
          },
          children: [],
        },
        // Right Secure
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          },
          children: [
            {
              id: generateId(),
              type: 'image' as ElementType,
              src: '/images/movyo/lockIcon.webp',
              alt: 'lockIcon',
              styles: {
                width: '20px',
                height: '20px',
                objectFit: 'contain',
              },
              responsiveStyles: {
                tablet: {
                  width: '18px',
                  height: '18px',
                },
                mobile: {
                  width: '16px',
                  height: '16px',
                },
              },
            },
            {
              id: generateId(),
              type: 'paragraph' as ElementType,
              content: 'Secure Order',
              styles: {
                color: '#317CF7',
                fontSize: '12px',
                fontWeight: '400',
                lineHeight: 'normal',
                textTransform: 'uppercase',
                margin: '0',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '11px',
                },
                mobile: {
                  fontSize: '10px',
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createVidalyticsVideoElement = (
  embedId: string,
  playerEvents?: {
    play?: () => void;
    pause?: () => void;
    ended?: () => void;
  }
): import('../types/builder').BuilderElement => ({
  id: generateId(),
  type: 'vidalytics-video' as ElementType,
  landscapeEmbedId: 'vidalytics_embed_Vn7BrqZcTWJkIhDQ',
  verticalEmbedId: 'vidalytics_embed_hGtLsXIz3ntQFBch',
  landscapeUrl: 'https://fast.vidalytics.com/embeds/hfwrJKPS/Vn7BrqZcTWJkIhDQ/',
  verticalUrl: 'https://fast.vidalytics.com/embeds/hfwrJKPS/hGtLsXIz3ntQFBch/',
  playerEvents,
  styles: {
    border: '7px solid background',
    borderRadius: '20px',
    backgroundColor: 'forground',
    display: 'block',
    width: '100%',
    maxWidth: '1200px',
    minHeight: '360px',
    maxHeight: '700px',
    margin: '0 auto',
    position: 'relative',
    overflow: 'hidden',
  },
});

const vslVideoSectionContainer = () => ({
  id: generateId(),
  type: 'container' as ElementType,
  styles: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundImage: `linear-gradient(180deg, #FFFFFF 0%, #94D5F4 82.38%)`,
    // backgroundImage: `linear-gradient(180deg, #FF9A3B 4.33%, #E77000 45.19%, #D75A00 100%)`,
    margin: 0,
    padding: '25px 0 25px',
  },
  children: [
    {
      id: generateId(),
      type: 'container' as ElementType,
      styles: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '24px',
      },
      children: [
        {
          id: generateId(),
          type: 'container' as ElementType,
          styles: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: '6px',
            justifyContent: 'center',
            alignItems: 'center',
          },
          children: [
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content: 'Doctors Don’t Want You to Know!',
              styles: {
                fontSize: '48px',
                fontWeight: '700',
                color: 'forground',
                margin: '0',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '32px',
                },
                mobile: {
                  fontSize: '20px',
                },
              },
            },
            {
              id: generateId(),
              type: 'heading' as ElementType,
              content:
                'Melts <span style="color:#e34444;">Stubborn Fat</span> Without Dieting',
              styles: {
                fontSize: '48px',
                fontWeight: '700',
                color: 'forground',
                margin: '0',
              },
              responsiveStyles: {
                tablet: {
                  fontSize: '32px',
                },
                mobile: {
                  fontSize: '20px',
                },
              },
            },
          ],
        },
        createVidalyticsVideoElement('vidalytics_embed_y8vfbXPEZPB92eV9', {
          play: () => console.log('Video played!'),
          pause: () => console.log('Video paused!'),
          ended: () => console.log('Video ended!'),
        }),
      ],
    },
  ],
});

const vslClaimTimerSectionContainer = () => ({
  id: generateId(),
  type: 'container' as ElementType,
  vslShowHide: true,
  styles: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `linear-gradient(180deg, #FF9A3B 4.33%, #E77000 45.19%, #D75A00 100%)`,
    margin: 0,
    gap: '28px',
    padding: '32px 0 32px',
  },
  children: [
    {
      id: generateId(),
      type: 'heading' as ElementType,
      content: 'Claim Your Discounted MOVYO',
      styles: {
        textShadow: '0px 3px 1px rgba(0, 0, 0, 0.25)',
        fontSize: '48px',
        fontWeight: '800',
        color: '#00FFE5',
        margin: '0',
        textAlign: 'center',
        letterSpacing: '-0.72px',
      },
    },
    {
      id: generateId(),
      type: 'heading' as ElementType,
      content: 'Below For Huge Savings',
      styles: {
        textShadow: '0px 3px 1px rgba(0, 0, 0, 0.25)',
        fontSize: '48px',
        fontWeight: '800',
        color: 'background',
        margin: '0',
        textAlign: 'center',
        letterSpacing: '-0.72px',
      },
    },
    {
      id: generateId(),
      type: 'paragraph' as ElementType,
      content: 'SPECIAL OFFER ENDS IN: XX:XX21 - BUY NOW',
      styles: {
        maxWidth: '1040px',
        fontSize: '30px',
        fontWeight: '700',
        color: 'background',
        margin: '0',
        textAlign: 'center',
      },
    },
    {
      id: generateId(),
      type: 'timer' as ElementType,
      countdownTimerSeconds: 1800,
      styles: {
        fontSize: '60px',
        fontWeight: '700',
        color: '#ff0000',
        margin: '24px 0 0',
        textAlign: 'center',
      },
    },
  ],
});

export const template2 = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig) as BuilderElement,
    hero: createHeroSection(globalConfig) as BuilderElement,
    testimoial: createTestimonialsHeaderSection(globalConfig) as BuilderElement,
    offerBelt: createOfferBeltSection(globalConfig) as BuilderElement,
    offerBelt2: createOfferBeltSection(globalConfig) as BuilderElement,
    intro: createProductIntroSection(globalConfig) as BuilderElement,
    whyWork: createWhyMovyoWorksSection(globalConfig) as BuilderElement,
    inside: createWhatsInsideSection(globalConfig) as BuilderElement,
    services: createServicesSection(globalConfig) as BuilderElement,
    offer: createOffersSection(globalConfig) as BuilderElement,
    pricing: createPricingSection(globalConfig) as BuilderElement,
    bonuses: createExclusiveBonusesSection(globalConfig) as BuilderElement,
    faq: createFAQSection(globalConfig) as BuilderElement,
    mentioned: createMentionedInSection(globalConfig) as BuilderElement,
    listing: createListingSection(globalConfig) as BuilderElement,
    partnerMenu: createPartnerMenuSection(globalConfig) as BuilderElement,
    footerMenu: createFooterMenuSection(globalConfig) as BuilderElement,
    footerEnd: createFooterEndSection(globalConfig) as BuilderElement,
  };
};

export const template2VSLTemplate = (globalConfig: GlobalConfig) => {
  return {
    embededVideo: vslVideoSectionContainer(),
    claimTimerSection: vslClaimTimerSectionContainer(),
    pricing: createPricingSection(globalConfig, true) as BuilderElement,
    testimoial: createTestimonialsHeaderSection(
      globalConfig,
      true
    ) as BuilderElement,
    intro: createProductIntroSection(globalConfig, true) as BuilderElement,
    claimTimerSection2: vslClaimTimerSectionContainer(),
    pricing2: createPricingSection(globalConfig, true) as BuilderElement,
    bonuses: createExclusiveBonusesSection(
      globalConfig,
      true
    ) as BuilderElement,
    faq: createFAQSection(globalConfig) as BuilderElement,
    mentioned: createMentionedInSection(globalConfig) as BuilderElement,
    listing: createListingSection(globalConfig) as BuilderElement,
    partnerMenu: createPartnerMenuSection(globalConfig) as BuilderElement,
    footerMenu: createFooterMenuSection(globalConfig) as BuilderElement,
    footerEnd: createFooterEndSection(globalConfig) as BuilderElement,
  };
};

// Export section creator functions for use in other templates
export {
  createTestimonialsHeaderSection,
  createMentionedInSection,
  createPartnerMenuSection,
  createListingSection,
  createFooterMenuSection,
  createFooterEndSection,
  createFAQSection,
};
